import {
  hero1,
  hero2,
  hero3,
  hero4,
  backgroundHero1,
  backgroundHero2,
  backgroundHero3,
  backgroundHero4,
  Dark_backgroundHero1,
  Dark_backgroundHero2,
  Dark_backgroundHero3,
  Dark_backgroundHero4,
  AboutUsImage,

  qutionMarkImage,
  video_Image
} from "../assets/images";
import { logo } from "../assets/svg";
import {
  GoHomeFill,
  HiOutlineMail,
  AiOutlineExclamationCircle,
  RiProductHuntLine,
  FaRegChartBar,
  FaFacebookF,
  FaInstagram,
  FaXTwitter,
  FaLinkedinIn,
  FaPhone,
  FaLocationDot,
  MdEmail,
} from "../components/icons";
import {
  icon1,
  icon2,
  icon3,
  icon4,
  GovernanceBg,
  MaximizingImpactBg,
  ImpactMeasurementBg,
  DigitalizationBg,
  GovernanceBg2,
  MaximizingImpactBg2,
  ImpactMeasurementBg2,
  DigitalizationBg2,
} from "../assets/svg/section4Icons";
import {
  card_image1,
  card_image2,
  card_image3,
  card_image4,
  card_image5,
  card_image6,
} from "../assets/images/section5Images";
import {
  s6_Icon1,
  s6_Icon2,
  s6_Icon3,
  s6_Icon4,
  s6_Icon5,
  s6_Icon6,
  s6_Icon1_d,s6_Icon2_d,s6_Icon3_d,s6_Icon4_d,s6_Icon5_d,s6_Icon6_d
} from "../assets/svg/section6icons";
import { homeLinkImage ,homeLinkImageDark,productsImage,dark_productsImage,ContentUsImage,dark_ContentUsImage,c_link_Image,c_Link_Image_Dark,aboutUs_link_Image_Dark,aboutUs_link_Image} from "../assets/images/headerImages";
import {s7_image1, s7_image2, s7_image3, s7_image4 } from "../assets/images/Secton7Images"

import {C_Hero1,C_Hero2,C_Hero3,C_Hero_Image1,C_Hero_Image2,C_Hero_Image3,C_Hero_Image1_dark,C_Hero_Image2_dark,C_Hero_Image3_dark} from "../assets/images/c_hero_Images"
import {c_blog_Bg1,c_blog_Bg2,c_blog_Bg3,c_blog_Bg4,c_blog_Bg5,c_blog_Bg6,c_blog_Bg7,c_blog_Bg8,
  c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4,c_blog_image5,c_blog_image6,c_blog_image7,c_blog_image8} from "../assets/images/c_blog_images" ;

  import {p_image1,p_image2,p_image3,p_image4,p_image5,p_image6} from "../assets/images/products_Images"
export const headerLinks = [
  {
    id: 1,
    nameEn: "Home",
    nameAr: "الرئيسية",
    icon: <GoHomeFill />,
    path: "/",
    image: homeLinkImage,
    image_Dark: homeLinkImageDark,
    description_Ar:"الصفحة الرئيسية لمنصة منافذ.",
    description_En:"The homepage of Manafith Platform.",
  },
  {
    id: 2,
    nameEn: "About Manafith",
    nameAr: "عن منافذ",
    icon: <AiOutlineExclamationCircle />,
    path: "/AboutUs",
    image: aboutUs_link_Image,
    image_Dark: aboutUs_link_Image_Dark,
    description_Ar:"معلومات حول منصة منافذ ورسالتها ورؤيتها.",
    description_En:"Information about Manafith Platform, its mission, and vision.",
  },
  {
    id: 3,
    nameEn: "Our products",
    nameAr: "منتجاتنا",
    icon: <RiProductHuntLine />,
    path: "/Products",
    image: productsImage,
    image_Dark: dark_productsImage,
    description_Ar:"استكشف منتجاتنا وحلولنا المبتكرة.",
    description_En:"Explore our innovative products and solutions.",
  },
  {
    id: 4,
    nameEn: "Charities",
    nameAr: "الجمعيات",
    icon: <FaRegChartBar />,
    path: "/Charities",
    image: c_link_Image,
    image_Dark: c_Link_Image_Dark,
    description_Ar: "إستكشف معنا منافذ للجمعيات",
    description_En: "Explore charitable organizations and their initiatives with us",
},
  {
    id: 5,
    nameEn: "Contact Us",
    nameAr: "تواصل معنا",
    icon: <HiOutlineMail />,
    path: "/ContactUs",
    image: ContentUsImage,
    image_Dark: dark_ContentUsImage,
    description_Ar:"تواصل مع فريقنا لأي استفسارات أو دعم.",
    description_En:"Get in touch with our team for any inquiries or support.",

  },
];

export const slides = [
  {
    id: 1,
    image: hero1,
    title_Ar: "مع منافذ",
    bakground: backgroundHero1,
    dark_background: Dark_backgroundHero1,
    subtitle_Ar: "التحوّل الذكي",
    title_En: "With Manafeh",
    subtitle_En: "Smart Transformation",
    description_En: `Manafeh delivers smart transformation for civic associations through an integrated system managing aid disbursement, data governance, and expansion across stores and service providers. Through our platform, associations gain complete control, managing aid distribution with digital tools that ensure transparency and oversight. Manafeh enables contracts with multiple stores while giving beneficiaries product choice freedom—preserving dignity and expanding options. More than a system, Manafeh opens future opportunities, elevating associations to entrepreneurial levels in the non-profit sector.`,
    description_Ar: `يقدّم "منافذ" تحولًا ذكيًا للجمعيات الأهلية عبر منظومة متكاملة لإدارة صرف المساعدات، حوكمة البيانات، والتوسّع في المتاجر ومزودي الخدمات. كيف نحقق ذلك؟ من خلال منصة "منافذ" تصبح الجمعية في موقع التحكم الكامل، حيث يمكنها إدارة صرف المساعدات والخدمات بأدوات رقمية حديثة تضمن الشفافية والرقابة والحوكمة. توفر "منافذ" للجمعيات القدرة على التعاقد مع أكثر من متجر في نفس الوقت، وترك حرية اختيار المنتجات للمستفيد، بما يعزز كرامته ويوسّع خياراته. منافذ ليست مجرد نظام، بل أداة تفتح للجمعيات باب المستقبل، وتنقلها إلى مستوى ريادي في عالم الققطاع غير الربحي.`
  },
  {
    id: 2,
    image: hero2,
    title_Ar: "مع منافذ",
    subtitle_Ar: "نهتم بمشاعرهم",
    title_En: "With Manafeh",
    subtitle_En: "Dignity Preservation",
    bakground: backgroundHero2,
    dark_background: Dark_backgroundHero2,
    description_En: `From the outset, Manafeh was never merely about documenting aid distribution—it was a genuine expression of respect for beneficiaries' feelings and commitment to preserving their dignity. We understood beneficiaries seek respect, not charity. Manafeh reshapes interactions by integrating conduct and procedures that protect privacy and provide associations with advanced tools, positioning them as caring entities rather than mere donors. Manafeh is a dignified solution for creating impact, aligned with Islamic values, government regulations, and Saudi associations' needs.`,
    description_Ar: `منذ اللحظة الأولى، لم تكن فكرة "منافذ" مجرّد توثيق لعمليات صرف المساعدات، بل كانت تعبيرًا صادقًا عن احترام مشاعر المستفيدين، وحرصًا على حفظ كرامتهم. كنا نعلم أن المستفيد لا يريد أن يبدو وكأنه يتلقى إحسانًا، بل يستحق أن يشعر بالاحترام أثناء استلام المساعدة. ولهذا، سعت "منافذ" إلى إعادة تشكيل طريقة التعامل، من خلال دمج السلوك والإجراءات بطريقة تحفظ للمستفيد خصوصيته، وتمنح الجمعية أدوات متطورة تُظهرها بمظهر الجهة الحريصة لا المعطية. "منافذ" ليست وسيلة صرف، بل وسيلة كريمة لتحقيق الأثر، تتماشى مع القيم الإسلامية، والأنظمة الحكومية، واحتياجات الجمعيات في المملكة العربية السعودية.`
  },
  {
    id: 3,
    image: hero3,
    title_Ar: "مع منافذ",
    subtitle_Ar: "الاستثمار الذكي",
    title_En: "With Manafeh",
    bakground: backgroundHero3,
    dark_background: Dark_backgroundHero3,
    subtitle_En: "Smart Investment",
    description_En: `With Manafeh, charitable associations transform from spending entities into investment hubs. Our platform offers smart investment opportunities during aid disbursement—through exclusive discounts, cashback, and tax refund benefits—all maximizing charitable budget impact. The benefits extend beyond associations to beneficiaries themselves; Manafeh enables stores to offer developmental and employment opportunities as part of their community contribution, turning aid receipt into integration and production opportunities. Manafeh transforms aid distribution from traditional activity into comprehensive investment benefiting associations, beneficiaries, and society.`,
    description_Ar: `لم تعد الجمعيات الخيرية مع "منافذ" مجرد جهة إنفاق، بل أصبحت جهة استثمار. تتيح "منافذ" للجمعيات فرصًا استثمارية ذكية عند صرف المساعدات، من خلال الحصول على خصومات حصرية، أو كاش باك، أو الاستفادة من الاسترداد الضريبي، وكلها تصب في تعظيم أثر الميزانية الخيرية. لكن الأثر لا يتوقف عند الجمعية فقط، بل يمتد إلى المستفيد نفسه؛ حيث تُمكّن "منافذ" المتاجر من تقديم فرص تنموية وتوظيفية للمستفيدين كجزء من مساهمتها المجتمعية، مما يحوّل رحلة الاستفادة إلى فرصة للاندماج والإنتاج. مع "منافذ"، يتحول صرف المساعدات من نشاط تقليدي إلى استثمار متكامل يعود نفعه على الجمعية والمستفيد والمجتمع.`
  },
  {
    id: 4,
    image: hero4,
    title_Ar: "مع منافذ",
    subtitle_Ar: "سوق بلا حدود",
    title_En: "With Manafeh",
    bakground: backgroundHero4,
    dark_background: Dark_backgroundHero4,
    subtitle_En: "Limitless Market",
    description_En: `Previously, associations were limited to single stores or providers, restricting expansion and diversity. With Manafeh, associations gain access to an integrated market of stores and services—within cities, beyond them, and across specialties. This diversity enables associations to meet diverse beneficiary needs, respecting their preferences and reinforcing their central importance. Manafeh opens new doors for association expansion, impact, and professionalism.`,
    description_Ar: `في السابق، كانت خيارات الجمعية محدودة بمتجر واحد أو مزود خدمة وحيد، مما فرض قيودًا على قدرتها في التوسع والتنوع. لكن مع "منافذ"، انتقلت الجمعيات من التعامل مع متجر إلى امتلاك قدرة الوصول إلى سوق متكامل من المتاجر والخدمات، داخل المدينة وخارجها، وفي مختلف التخصصات. هذا التنوّع يُمكّن الجمعيات من تلبية احتياجات شرائح متعددة من المستفيدين، بما يعكس احترام أذواقهم، ويعزز شعورهم بأنهم محور الاهتمام. "منافذ" تفتح أمام الجمعيات أبوابًا جديدة للانتشار، والتأثير، والاحتراف.`
  },
];
export const counterItems = [
  {
    number: 362,
    text_Ar: "جمعية أهلية",
    text_En: "Charity Associations",
  },
  {
    number: 2542,
    text_Ar: "نقطة بيع",
    text_En: "Points of Sale",
  },
  {
      number: 215731,
    text_Ar: "مستفيد",
    text_En: "Beneficiaries",
  },
  {
    number: 7,
    text_Ar: "مؤسسة مانحة",
    text_En: "Granting Organizations",
  },
  {
    number: 3,
    text_Ar: "أوقاف",
    text_En: "Endowments",
  },
  {
    number: 15,
    text_Ar: "شركاء",
    text_En: "Partners",
  },
];
export const AboutUsData = {
  Main_title_Ar: "ما هي منصة منافذ",
  Main_title_En: "What is Manafith Platform",

  Main_description_Ar:
    "منصة منافذ هي أول نظام سعودي صُمّم خصيصًا لإدارة صرف ومناولة المساعدات بأسلوب ذكي ومنظّم. فهمت المنصة أدوار الجمعيات، واحتياجات المستفيدين، وتطلعات المتاجر، ومتطلبات الجهات الإشرافية، ثم جمعتهم جميعًا في بيئة رقمية واحدة تعمل بسلاسة وشفافية. لم يعد المستفيد مجرد متلقٍّ للمساعدات عبر الجمعية او مندوبيها ، بل أصبح متسوّقًا محترمًا يُعامل كأي متسوّق طبيعي، له خيارات، وحقوق، وحرية. حوّلت منصة منافذ الجمعيات من التشغيل التقليدي إلى تشغيل رقمي، ومن التخزين والتوزيع إلى أسلوب تكيف، وإشراف، ومتابعة. ولم تعد الجمعية فقط جهة باحثة عن تعاون ، بل أصبحت صانعة فرص وشراكات يسعى لها القطاع التجاري و الخدمي ، منصة منافذ رفعت مستوى الحوكمة، وفعّلت الرقمنة، ومكّنت الجمعيات من القيادة، وحققت أثرًا ملموسًا بشكل مباشر وفعّال على أرض الواقع. منصة منافذ ليست مجرد أداة تقنية، بل أسلوب جديد في إدارة العمل الخيري باحتراف. مرحباً بكم في عالم يُدار فيه الخير كما يجب.",

  Main_description_En:
    "Manafith Platform is the first Saudi system specifically designed for the smart and organized management of aid disbursement and handling. The platform understands the roles of charities, the needs of beneficiaries, the aspirations of stores, and the requirements of regulatory bodies, then brings them all together in a single digital environment that operates smoothly and transparently. The beneficiary is no longer just a recipient of aid through the charity or its representatives, but has become a respected shopper treated like any regular shopper, with choices, rights, and freedom. Manafith Platform has transformed charities from traditional operation to digital operation, and from storage and distribution to a method of adaptation, supervision, and follow-up. The charity is no longer just an entity seeking cooperation, but has become a creator of opportunities and partnerships sought by the commercial and service sectors. Manafith Platform has raised the level of governance, activated digitalization, empowered charities to lead, and has achieved a tangible impact directly and effectively on the ground. Manafith Platform is not just a technical tool, but a new method for managing charitable work professionally. Welcome to a world where goodness is managed as it should be.",

  Second_title_Ar: "الرسالة",
  Second_title_En: "Mission",
  second_description_Ar:
    "حفظ كرامة المستفيدين و الارتقاء بهم من خلال دمج سلوك صرف المساعدات بالسلوك الشرائي الحديث ",
  second_description_En:
    "Preserving the dignity of beneficiaries and uplifting them by integrating the behavior of aid disbursement with modern purchasing behavior",

  Third_title_Ar: "الرؤية",
  Third_title_En: "Vision",
  Third_description_Ar:
    "إنشاء شراكة مجتمعية بين القطاع الخيري والقطاع التجاري لرفع جودة الخدمات المقدمة للمستفيدين",
  Third_description_En:
    "Establishing a community partnership between the charitable sector and the commercial sector to improve the quality of services provided to beneficiaries",

  buttonText_Ar: "ملفنا التعريفي",
  buttonText_En: "Our Profile",
  image: AboutUsImage,
};

export const WhyManafithData = {
  Main_title_Ar: "كيف تعمل منصة منافذ ببساطة ؟",
  Main_title_En: "How does Manafith Platform work simply?",
  Main_description_Ar:
    "في منافذ، لا تحتاج الجمعية إلى التخزين أو التوزيع بنفسها، بل تتحول إلى جهة تنسيق عالية الكفاءة، تتكامل مع السوق المحلي لخدمة المستفيدين عبر نموذج رقمي موحّد.\n• تقوم الجمعية بتحديد نوع المساعدات المطلوبة، ثم تتعاقد عبر المنصة مع المتاجر ومزودي الخدمات المناسبين.\n• بعد ذلك، تصدر الجمعية بطاقات إلكترونية أو قسائم شرائية للمستفيدين، وتُرسل إليهم مباشرة برسالة نصية أو عبر التطبيق الذكي.\n• يمكن للمستفيد استخدام البطاقة في الوقت المناسب له، لدى أي من المتاجر المتاحة في منطقته، دون انتظار طابور توزيع أو زيارات ميدانية.",
  Main_description_En:
    "At Manafith, the charity does not need to store or distribute aid itself, but rather transforms into a highly efficient coordinating entity that integrates with the local market to serve beneficiaries through a unified digital model.\n• The charity specifies the type of aid required, then contracts through the platform with suitable stores and service providers.\n• After that, the charity issues electronic cards or shopping vouchers to beneficiaries, sending them directly via text message or through the smart application.\n• The beneficiary can use the card at a time that suits them, at any of the available stores in their area, without waiting in a distribution queue or field visits.",
  Second_title_Ar: "ما يميز تظام منافذ؟",
  Second_title_En: "What distinguishes Manafith System?",
  Second_description_Ar:
    "• البطاقة الواحدة يمكن ربطها بعدة متاجر في نفس الوقت، مما يمنح المستفيد حرية الاختيار.\n• يمكن أن تحتوي البطاقة على أكثر من مشروع: سلة غذائية، كساء، أجهزة كهربائية، خدمات طبية... وكل نوع منها مرتبط تلقائيًا بالمتاجر أو المزودين المعتمدين.\n• جميع العمليات تتم عبر واجهات رقمية سهلة وآمنة، مع تتبع دقيق وتحكم كامل للجمعية.\n• بهذه الآلية، تنتقل الجمعية من التشغيل اليدوي إلى منظومة ذكية تُمكّنها من التركيز على الأثر ، بدلاً من الانشغال بالعمليات اللوجستية.",
  Second_description_En:
    "• A single card can be linked to multiple stores simultaneously, giving the beneficiary freedom of choice.\n• The card can contain multiple projects: food basket, clothing, electrical appliances, medical services... each type is automatically linked to approved stores or providers.\n• All operations are conducted through easy and secure digital interfaces, with precise tracking and full control for the charity.\n• With this mechanism, the charity transitions from manual operation to a smart system that enables it to focus on impact and effectiveness, rather than being preoccupied with logistical operations",
  
};

export const Section4Data = {
  title_Ar: "أهم مخرجات منصة منافذ",
  title_En: "Key Outcomes of Manafith Platform",

  cards: [
    {
      id: 1,
      title_Ar: "قياس الأثر",
      title_En: "Impact Measurement",
      description_Ar:
        "في منافذ، قياس الأثر هو حجر الزاوية لتحسين المساعدات وضمان تحقيق أهدافها الخيرية. يتم ذلك عبر تتبع استفادة المستفيدين، قياس رضاهم عن الدعم ومزودي الخدمات، ورصد تفاصيل الاستفادة بدقة. هذه المؤشرات تمنح الجهات الخيرية رؤية شاملة لتقييم الأثر",
      description_En:
        "At Manafith, impact measurement is the cornerstone for improving aid and ensuring it achieves its charitable objectives. This is done by tracking beneficiary utilization, measuring their satisfaction with the support and service providers, and accurately monitoring the details of utilization. These indicators provide charitable organizations with a comprehensive view to assess impact.",
      icon: icon1,
      background: ImpactMeasurementBg,
      background2: ImpactMeasurementBg2,
      color: "#258ACA",
    },
    {
      id: 2,
      title_Ar: "تعظيم الأثر",
      title_En: "Maximizing Impact",
      description_Ar:
        "في منافذ، نعظم الأثر عبر مسارين رئيسيين: الأثر المالي من خلال توفير خصومات واسترداد ضريبي يعزز قدرة الجمعيات الشرائية، والأثر غير المالي عبر توظيف المستفيدين، دعم منتجات الأسر المنتجة، والمساهمة في نشر مشاريع الجمعيات. نظامنا يقلل التكاليف ويضاعف الفائدة، لتحقيق أثر مستدام وممي",
      description_En:
        "At Manafith, we maximize impact through two main avenues: financial impact by providing discounts and tax refunds that enhance the purchasing power of charities, and non-financial impact by employing beneficiaries, supporting products from productive families, and contributing to the dissemination of charity projects. Our system reduces costs and multiplies benefits to achieve sustainable and distinctive impact.",
      icon: icon2,
      background: MaximizingImpactBg,
      background2: MaximizingImpactBg2,
      color: "#22E0EE",
    },
    {
      id: 3,
      title_Ar: "الرقمنة",
      title_En: "Digitalization",
      description_Ar:
        "منافذ يقدّم الرقمنة بأسلوب مبتكر يعتمد على الرقمنة المؤتمتة . جميع التقارير تُكتب تلقائيًا بواسطة الأنظمة دون تدخل يدوي، حيث يتم رصد الأحداث من بداية صرف المساعدة حتى إصدار تقرير الدعم. هذا الأسلوب المؤتمت يجعل التقارير دقيقة، موثوقة، وسريعة، مما يعزز كفاءة الشفافية و المصداقية .",
      description_En:
        "Manafith offers digitalization in an innovative way based on automated digitization. All reports are automatically generated by systems without manual intervention, as events are tracked from the beginning of aid disbursement to the issuance of the support report. This automated approach makes reports accurate, reliable, and fast, enhancing efficiency, transparency, and credibility.",
      icon: icon3,
      background: DigitalizationBg,
      background2: DigitalizationBg2,
      color: "#EE7622",
    },
    {
      id: 4,
      title_Ar: "الحوكمة",
      title_En: "Governance",
      description_Ar:
        "منافذ يعزز الحوكمة في القطاع الخيري  من خلال  تنظيم وإدارة صرف ومناولة  المساعدات عبر آليات تقنية مبتكرة. توفر أدوات للتوثيق، الشفافية، و التتبع المباشر و اللحظي ، مما يساعد الجهات الخيرية على تحقيق أهدافها بكفاءة وعدالة، وضمان وصول الدعم لمستحقيه بأسلوب رقمي عالي التقنية",
      description_En:
        "Manafith enhances governance in the charitable sector by organizing and managing the disbursement and handling of aid through innovative technological mechanisms. It provides tools for documentation, transparency, and real-time tracking, helping charitable organizations achieve their goals efficiently and fairly, ensuring that support reaches its rightful recipients through a highly technical digital approach.",
      icon: icon4,
      background: GovernanceBg,
      background2: GovernanceBg2,
      color: "#5D00FF",
    },
  ],
};
export const Section5Data = {
  title_Ar: "منافذ صمم للجميع",
  title_En: "Manafith is designed for everyone",
  subtitle_Ar: "(حدد نشاطك أو اهتمامك .. واكتشف منصة منافذ)",
  subtitle_En:
    "(Select your activity or interest .. and discover Manafith Platform)",
  cards: [
    {
      id: 1,
      path: "/",
      title_Ar: "جهة وقفية",
      title_En: "Endowment Entity",
      subtitle_Ar: "(للمؤسسات الوقفية)",
      subtitle_En: "(For Endowment Institutions)",
      image: card_image1,
    },
    {
      id: 2,
      path: "/",
      title_Ar: "مؤسسة مانحة",
      title_En: "Granting Organization",
      subtitle_Ar: "(للمؤسسات المانحة)",
      subtitle_En: "(For Granting Organizations)",
      image: card_image2,
    },
    {
      id: 3,
      path: "/charities",
      title_Ar: "جمعية خيرية",
      title_En: "Charitable Association",
      subtitle_Ar: "(للجمعيات الخيرية)",
      subtitle_En: "(For Charitable Associations)",
      image: card_image3,
    },
    {
      id: 4,
      path: "/",
      title_Ar: "منصة حكومية",
      title_En: "Governmental Platform",
      subtitle_Ar: "(للمؤسسات والمنصات الحكومية)",
      subtitle_En: "(For Governmental Entities and Platforms)",
      image: card_image4,
    },
    {
      id: 5,
      path: "/",
      title_Ar: "متجر",
      title_En: "Store",
      subtitle_Ar: "(للمتاجر ومزودي الخدمات)",
      subtitle_En: "(For Stores and Service Providers)",
      image: card_image5,
    },
    {
      id: 6,
      path: "/",
      title_Ar: "شركة برمجية",
      title_En: "Software Company",
      subtitle_Ar: "(لشركات البرمجيات التتي تستهدف القطاع الخيري )",
      subtitle_En: "(For Software Companies Targeting the Charitable Sector)",
      image: card_image6,
    },
  ],
};
export const Section6Data = {
  title_Ar: "منافذ حلول متكاملة",
  title_En: "Manafith Integrated Solutions",
  subtitle_Ar: "الوحدات الإسنادية والخدمية لنظام منافذ",
  subtitle_En: "Support and Service Units of Manafith System",
  description_Ar:
    "<p>منصة <strong>منافذ</strong> بُنيت على فهم عميق لاحتياج العمل الخيري و بناء عليه اطلقت وحدات إسنادية مترابطة، تعمل قبل وأثناء وبعد تنفيذ الدعم، لتُشكل منظومة احترافية تُعزز الكفاءة، وتضمن الشفافية، وتحقق التكامل في إدارة مشاريع الدعم</p>\n<p>أبرز الوحدات الإسنادية في منافذ:</p>\n<ul>\n<li><strong>منافذ تقييم</strong> : لرصد رضا المستفيدين وتحسين الخدمات.</li>\n<li><strong>منافذ استبيان</strong> : لجمع وتحليل آراء المستفيدين والجمعيات.</li>\n<li><strong>منافذ مانحين</strong> : لمتابعة المشاريع و الدعوم بدقة و شفافية .</li>\n<li><strong>منافذ توصيل</strong> : لإدارة تسليم المساعدات العينية بكفاءة.</li>\n<li><strong>منافذ مرفقات</strong> : لتبادل الوثائق والمستندات بأمان.</li>\n<li><strong>منافذ تواصل</strong> : لتعزيز قنوات الاتصال مع المستفيدين بسرية عالية.</li>\n</ul>",
  description_En:
    "<p>The <strong>Mawafid</strong> platform was built on a deep understanding of the needs of charitable work and accordingly launched interconnected support units that operate before, during, and after the implementation of support, forming a professional system that enhances efficiency, ensures transparency, and achieves integration in managing support projects.</p>\n<p>Key support units in Mawafid:</p>\n<ul>\n<li><strong>Mawafid Evaluation</strong>: To monitor beneficiary satisfaction and improve services.</li>\n<li><strong>Mawafid Survey</strong>: To collect and analyze opinions of beneficiaries and associations.</li>\n<li><strong>Mawafid Donors</strong>: To accurately and transparently track projects and support.</li>\n<li><strong>Mawafid Delivery</strong>: To efficiently manage the delivery of in-kind assistance.</li>\n<li><strong>Mawafid Attachments</strong>: To securely exchange documents and files.</li>\n<li><strong>Mawafid Communication</strong>: To enhance communication channels with beneficiaries with high confidentiality.</li>\n</ul>",
  icons: [
    {
      id: 1,
      icon: s6_Icon1,
      darkIcon:s6_Icon1_d,
    },
    {
      id: 2,
      icon: s6_Icon2,
      darkIcon:s6_Icon2_d,
    },
    {
      id: 3,
      icon: s6_Icon3,
      darkIcon:s6_Icon3_d,
    },
    {
      id: 4,
      icon: s6_Icon4,
      darkIcon:s6_Icon4_d,
    },
    {
      id: 5,
      icon: s6_Icon5,
      darkIcon:s6_Icon5_d,
    },
    {
      id: 6,
      icon: s6_Icon6,
      darkIcon:s6_Icon6_d,
    },
    {
      id: 7,
      icon: s6_Icon1,
      darkIcon:s6_Icon1_d,
    },
    {
      id: 8,
      icon: s6_Icon2,
      darkIcon:s6_Icon2_d,
    },
   
  ],
};
export const Section7Data = [
  {id:1,
    title_Ar: "منافذ حلول متكاملة",
    title_En: "Manafith Integrated Solutions",
    subtitle_Ar: "الوحدات الإسنادية والخدمية لنظام منافذ",
    subtitle_En: "Support and Service Units of Manafith System",
    description_Ar:
      "<p>منصة <strong>منافذ</strong> بُنيت على فهم عميق لاحتياج العمل الخيري و بناء عليه اطلقت وحدات إسنادية مترابطة، تعمل قبل وأثناء وبعد تنفيذ الدعم، لتُشكل منظومة احترافية تُعزز الكفاءة، وتضمن الشفافية، وتحقق التكامل في إدارة مشاريع الدعم</p>\n<p>أبرز الوحدات الإسنادية في منافذ:</p>\n<ul>\n<li><strong>منافذ تقييم</strong> : لرصد رضا المستفيدين وتحسين الخدمات.</li>\n<li><strong>منافذ استبيان</strong> : لجمع وتحليل آراء المستفيدين والجمعيات.</li>\n<li><strong>منافذ مانحين</strong> : لمتابعة المشاريع و الدعوم بدقة و شفافية .</li>\n<li><strong>منافذ توصيل</strong> : لإدارة تسليم المساعدات العينية بكفاءة.</li>\n<li><strong>منافذ مرفقات</strong> : لتبادل الوثائق والمستندات بأمان.</li>\n<li><strong>منافذ تواصل</strong> : لتعزيز قنوات الاتصال مع المستفيدين بسرية عالية.</li>\n</ul>",
    description_En:
      "<p>The <strong>Mawafid</strong> platform was built on a deep understanding of the needs of charitable work and accordingly launched interconnected support units that operate before, during, and after the implementation of support, forming a professional system that enhances efficiency, ensures transparency, and achieves integration in managing support projects.</p>\n<p>Key support units in Mawafid:</p>\n<ul>\n<li><strong>Mawafid Evaluation</strong>: To monitor beneficiary satisfaction and improve services.</li>\n<li><strong>Mawafid Survey</strong>: To collect and analyze opinions of beneficiaries and associations.</li>\n<li><strong>Mawafid Donors</strong>: To accurately and transparently track projects and support.</li>\n<li><strong>Mawafid Delivery</strong>: To efficiently manage the delivery of in-kind assistance.</li>\n<li><strong>Mawafid Attachments</strong>: To securely exchange documents and files.</li>\n<li><strong>Mawafid Communication</strong>: To enhance communication channels with beneficiaries with high confidentiality.</li>\n</ul>",
      image:s7_image1,
  },
  {
    id: 2,
    title_Ar: "وجهة نظر منافذ",
    title_En: "Manafith Perspective",
    subtitle_Ar:"الفرق بين الصرف والمناولة",
    subtitle_En:"The Difference Between Disbursement and Handover",
    description_Ar: "في منصة منافذ لا ننظر إلى عملية الدعم على أنها مجرد \"صرف\"، بل نؤمن بمفهوم أعمق هو \"المناولة\". الصرف هو مجرد تسجيل خروج للمساعدة من الجمعية، أما المناولة فهي التأكد من أن الدعم وصل فعليًا إلى المستفيد عبر وسائل شفافة ومثبتة قابلة للقياس و التتبع و التقييم و الرضا. المناولة تعني الكفاءة، الموثوقية، والتوثيق، وهي أساس تحقيق الأثر الحقيقي. لهذا، تعتمد منافذ على نظام تقني دقيق يُوثق عملية المناولة ويوفر الشفافية التي تؤكد من استلم و متى و من اين و ماذا .",
    description_En: "<p>At the <strong>Manafith</strong> platform, we do not view the support process as merely a \"disbursement,\" but we believe in a deeper concept: \"Handover.\" Disbursement is simply the logging of aid exiting the association, whereas Handover is the assurance that support has actually reached the beneficiary through transparent, verifiable, measurable, traceable, evaluable, and satisfactory means.</p><p>Handover signifies efficiency, reliability, and documentation, and it is the foundation for achieving real impact. Therefore, Manafith relies on a precise technical system that documents the handover process and provides the transparency that confirms <strong>who</strong> received it, <strong>when</strong>, <strong>from where</strong>, and <strong>what</strong>.</p>",
    image:s7_image2,
  },
  {
    id: 3,
    subtitle_Ar:"",
    subtitle_En:"",
    title_Ar: "الصرف",
    title_En: "Disbursement",
    description_Ar: "هي العملية التي تقوم بها الجمعية بتسجيل خروج المساعدة من عهدتها إلى المستفيدين، سواء كانت مالية أو عينية. لكن الصرف لا يعني بالضرورة أن المساعدة وصلت فعليًا إلى المستفيد.",
    description_En: "It is the process by which the association registers the exit of aid from its custody to the beneficiaries, whether financial or in-kind. However, disbursement does not necessarily mean that the aid has actually reached the beneficiary.",
    image:s7_image3,
    },
    {
      id: 4,
      title_Ar: "المناولة",
      title_En: "Handover",
      subtitle_Ar:"",
      subtitle_En:"",
      description_Ar: "هي المرحلة التي يتم فيها استلام المستفيد للمساعدة بشكل مباشر ومؤكد، سواء من قِبل الجمعية أو من خلال مزودي الخدمات والمتاجر. لذا تُعد المناولة حجر الأساس في عملية التوثيق الفعلي لوصول الدعم.",
      description_En: "It is the stage where the beneficiary receives the assistance directly and confirmed, whether by the association or through service providers and stores. Therefore, handover is the cornerstone of the actual documentation process for the arrival of support.",
      image:s7_image4,
      }
];

export const mapData={
  title_Ar:"منافذ بالخريطة ",
  title_En:"Manafith in map",
subtitle_Ar:"خريطة توضح إنتشار  المتاجر والجمعيات",
subtitle_En:"Map showing the spread of stors and Charities",
maps:[
  {
    id:1,
    title_En:"All",
    title_Ar:"الكل",
    map:  <iframe src="https://www.google.com/maps/d/embed?mid=1LOmYeyspodEyTXqSDAnYwa2TbtdQjwY&ehbc=2E312F"
    className=' rounded-xl w-full lg:h-[600px] md:h-[500px] h-[400px]'
 ></iframe>
  },
  {
    id:2,
    title_En:"Charities",
    title_Ar:"الجمعيات",
    map:  <iframe src="https://www.google.com/maps/d/embed?mid=1LOmYeyspodEyTXqSDAnYwa2TbtdQjwY&ehbc=2E312F"
    className=' rounded-xl w-full lg:h-[600px] md:h-[500px] h-[400px]'
 ></iframe>
  },
  {
    id:3,
    title_En:"stors",
    title_Ar:"المتاجر",
    map:  <iframe src="https://www.google.com/maps/d/embed?mid=1LOmYeyspodEyTXqSDAnYwa2TbtdQjwY&ehbc=2E312F"
    className=' rounded-xl w-full lg:h-[600px] md:h-[500px] h-[400px]'
 ></iframe>
  },

]
}
export const footerData = {
  colom1: {
    image: logo,
    title_Ar: "منصة منافذ الحل المتكامل لمناولة المساعدات والخدمات",
    title_En:
      "Manafith Platform: The Integrated Solution for Aid and Service Handling",
    social: [
      { id: 1, icon: <FaFacebookF />, path: "https://www.facebook.com/manafith/" },
      { id: 2, icon: <FaInstagram />, path: "https://www.instagram.com/manafithsys/" },
      { id: 3, icon: <FaXTwitter />, path: "https://x.com/manafith" },
      { id: 4, icon: <FaLinkedinIn />, path: "/" },
    ],
  },

  colom2: {
    title_Ar: "سياسة الخصوصية",
    title_En: "Privacy Policy",
    links: [
      {
        id: 1,
        title_Ar: "مقدمة",
        title_En: "Introduction",
        description_Ar: `<p>في منصة منافذ، نحن نولي أقصى درجات الأهمية لحماية بيانات عملائنا وزوار موقعنا. توضح هذه السياسة كيفية جمع البيانات، استخدامها، وحمايتها وفقًا للمعايير التقنية والقانونية المعتمدة.</p>`,
        description_En: `<p>At Manafith platform, we place the utmost importance on protecting our clients' and website visitors' data. This policy explains how data is collected, used, and protected according to approved technical and legal standards.</p>`
      },
      {
        id: 2,
        title_Ar: "جمع المعلومات",
        title_En: "Information Collection",
        description_Ar: `<p>عند استخدام موقع منافذ، قد نقوم بجمع المعلومات التالية:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>المعلومات التي تقدمها عند التسجيل</strong>: مثل الاسم، البريد الإلكتروني، وبيانات الاتصال.</li>
  <li><strong>بيانات الاستخدام</strong>: التي تساعدنا في تحسين تجربة المستخدم، مثل الصفحات التي تزورها ومدى تفاعلك مع المحتوى.</li>
  <li><strong>المعلومات التقنية</strong>: مثل عنوان الـIP، ونوع الجهاز والمتصفح المستخدم للوصول إلى الموقع.</li>
  </ul>`,
        description_En: `<p>When using the Manafith website, we may collect the following information:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Information you provide during registration</strong>: such as name, email, and contact details.</li>
  <li><strong>Usage data</strong>: that helps us improve user experience, such as pages you visit and your interaction with content.</li>
  <li><strong>Technical information</strong>: such as IP address, device type, and browser used to access the website.</li>
  </ul>`
      },
      {
        id: 3,
        title_Ar: "كيفية استخدام البيانات",
        title_En: "Data Usage",
        description_Ar: `<p>نستخدم المعلومات التي نجمعها من أجل:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>تحسين تجربة المستخدم</strong>: وتقديم محتوى مخصص لكل فئة من العملاء.</li>
  <li><strong>تطوير خدماتنا</strong>: بما يتناسب مع احتياجات الجمعيات الخيرية، المؤسسات المانحة، والمتاجر.</li>
  <li><strong>إرسال تحديثات وإشعارات</strong>: حول خدمات منافذ، إذا وافقت على ذلك.</li>
  <li><strong>تعزيز الأمان</strong>: وحماية المستخدمين من أي استخدام غير قانوني.</li>
  </ul>`,
        description_En: `<p>We use the information we collect for:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Improving user experience</strong>: and providing customized content for each customer segment.</li>
  <li><strong>Developing our services</strong>: to meet the needs of charitable associations, donor institutions, and stores.</li>
  <li><strong>Sending updates and notifications</strong>: about Manafith services, if you consent to this.</li>
  <li><strong>Enhancing security</strong>: and protecting users from any illegal use.</li>
  </ul>`
      },
      {
        id: 4,
        title_Ar: "مشاركة البيانات",
        title_En: "Data Sharing",
        description_Ar: `<p>منافذ لا تبيع أو تشارك بياناتك مع أي طرف ثالث، ولكن قد نشارك بعض البيانات في الحالات التالية:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>مع الجهات الحكومية المختصة</strong>: عند الحاجة، لضمان الامتثال للوائح والأنظمة.</li>
  <li><strong>مع شركائنا التقنيين</strong>: الذين يساعدون في تشغيل خدماتنا، بشرط التزامهم بحماية بياناتك.</li>
  </ul>`,
        description_En: `<p>Manafith does not sell or share your data with any third party, but we may share some data in the following cases:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>With relevant government authorities</strong>: when necessary, to ensure compliance with regulations and laws.</li>
  <li><strong>With our technical partners</strong>: who help operate our services, provided they commit to protecting your data.</li>
  </ul>`
      },
      {
        id: 5,
        title_Ar: "أمان المعلومات",
        title_En: "Information Security",
        description_Ar: `<p>نطبق أعلى معايير الأمان الرقمي لحماية بياناتك من الوصول غير المصرح به، بما في ذلك:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>تشفير البيانات</strong>: أثناء النقل والتخزين.</li>
  <li><strong>بروتوكولات حماية متقدمة</strong>: ضد الهجمات الإلكترونية.</li>
  <li><strong>وصول محدود</strong>: للبيانات الحساسة داخل المنصة.</li>
  </ul>`,
        description_En: `<p>We apply the highest digital security standards to protect your data from unauthorized access, including:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Data encryption</strong>: during transmission and storage.</li>
  <li><strong>Advanced protection protocols</strong>: against cyber attacks.</li>
  <li><strong>Limited access</strong>: to sensitive data within the platform.</li>
  </ul>`
      },
      {
        id: 6,
        title_Ar: "حقوق المستخدمين",
        title_En: "User Rights",
        description_Ar: `<p>يمكنك في أي وقت:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>طلب تحديث بياناتك الشخصية أو حذفها</strong>.</li>
  <li><strong>إلغاء الاشتراك من الرسائل الترويجية</strong>.</li>
  <li><strong>الاستفسار عن كيفية استخدام بياناتك</strong>: عبر التواصل معنا.</li>
  </ul>
  <p>لمزيد من التفاصيل أو للاستفسارات، يمكنك التواصل معنا عبر <strong>INFO@Manafith.sa</strong> أو <strong>920001168</strong></p>`,
        description_En: `<p>You can at any time:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Request updating or deletion of your personal data</strong>.</li>
  <li><strong>Unsubscribe from promotional messages</strong>.</li>
  <li><strong>Inquire about how your data is used</strong>: by contacting us.</li>
  </ul>
  <p>For more details or inquiries, you can contact us at <strong>INFO@Manafith.sa</strong> or <strong>920001168</strong></p>`
      }
    ]
  },

  colom3: {
    title_Ar: "الشروط والأحكام",
    title_En: "Terms and Conditions",
    links: [
      {
        id: 7,
        title_Ar: "المقدمة",
        title_En: "Introduction",
        description_Ar: `<p>رحبًا بك في منصة منافذ! باستخدامك لهذا الموقع، فإنك توافق على الالتزام بالشروط والأحكام التالية. إذا كنت لا توافق على أي جزء من هذه الشروط، يُرجى عدم استخدام الموقع.</p>`,
        description_En: `<p>Welcome to the Manafith platform! By using this website, you agree to comply with the following terms and conditions. If you do not agree to any part of these terms, please do not use the website.</p>`
      },
      {
        id: 8,
        title_Ar: "استخدام الموقع",
        title_En: "Website Use",
        description_Ar: `<p>عند استخدام موقع منافذ، فإنك توافق على:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>استخدام الموقع للأغراض المشروعة فقط</strong> وعدم إساءة استخدام الخدمات.</li>
  <li><strong>عدم محاولة اختراق أو التلاعب بأنظمة المنصة</strong>.</li>
  <li><strong>عدم نشر أو مشاركة أي محتوى غير قانوني، مسيء، أو احتيالي</strong>.</li>
  </ul>`,
        description_En: `<p>When using the Manafith website, you agree to:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Use the website for legitimate purposes only</strong> and not misuse the services.</li>
  <li><strong>Not attempt to hack or manipulate the platform's systems</strong>.</li>
  <li><strong>Not publish or share any illegal, offensive, or fraudulent content</strong>.</li>
  </ul>`
      },
      {
        id: 9,
        title_Ar: "حقوق الملكية الفكرية",
        title_En: "Intellectual Property Rights",
        description_Ar: `<p>جميع المحتويات، التصاميم، والشعارات على هذا الموقع محمية بموجب قوانين الملكية الفكرية، ولا يجوز إعادة استخدامها أو نشرها دون إذن رسمي من منافذ.</p>`,
        description_En: `<p>All content, designs, and logos on this website are protected under intellectual property laws and may not be reused or published without official permission from Manafith.</p>`
      },
      {
        id: 10,
        title_Ar: "تعديل الشروط",
        title_En: "Modification of Terms",
        description_Ar: `<p>يحق لـ منافذ تعديل هذه الشروط في أي وقت، وسيتم إخطار المستخدمين بأي تغييرات رئيسية. استمرارك في استخدام الموقع يعني قبولك للشروط المعدلة.</p>`,
        description_En: `<p>Manafith reserves the right to modify these terms at any time, and users will be notified of any major changes. Your continued use of the website means you accept the modified terms.</p>`
      },
      {
        id: 11,
        title_Ar: "إخلاء المسؤولية",
        title_En: "Disclaimer",
        description_Ar: `<p>المعلومات والخدمات المقدمة عبر الموقع هي لأغراض توضيحية فقط، ولا تتحمل منافذ أي مسؤولية عن أي أضرار ناتجة عن استخدام الموقع أو الاعتماد على المعلومات الواردة فيه.</p>
  <p>لمزيد من التفاصيل أو للاستفسارات، يمكنك التواصل معنا عبر <strong>INFO@Manafith.sa</strong> أو <strong>920001168</strong></p>`,
        description_En: `<p>The information and services provided through the website are for illustrative purposes only, and Manafith is not responsible for any damages resulting from the use of the website or reliance on the information contained therein.</p>
  <p>For more details or inquiries, you can contact us at <strong>INFO@Manafith.sa</strong> or <strong>920001168</strong></p>`
      }
    ]
  },
  colom4: {
    title_Ar: "تواصل معنا",
    title_En: "Contact Us",
    contacts: [
      {
        id: 12,
        text_Ar: "966500771478",
        text_En: "966500771478",
        icon: <FaPhone />,
      },
      {
        id: 13,
        text_Ar: "السعودية - القصيم - بريدة",
        text_En: "Saudi Arabia - Qassim - Buraidah",
        icon: <FaLocationDot />,
      },
      {
        id:14,
        text_Ar: "Info@manafith.sa",
        text_En: "Info@manafith.sa",
        icon: <MdEmail />,
      },
    ],
  },
};

export const  C_HeroData=[
  {
    id:1 ,
    smallTitle_Ar:"منذ 2011",
    smallTitle_En:"Since 2011",
    title_Ar:"تعمقنا",
    title_En:"We have deepened",
    subtitle_Ar:"لصرف المناولات والمساعدات",
    subtitle_En:"in disbursing handovers and aid",
    description_Ar:"هنا تبدأ رحلتك في فهم منصة منافذ بشكل أعمق، من وجهة نظر الجمعية الخيرية. ستجد في هذه الصفحة مقالات مختصرة وثرية تجيب عن كل ما يشغل بالك: ما هو منافذ ؟ لماذا تم إنشاؤه ؟ كيف يعمل ؟ وما القيمة المضافة ؟ مع بعض المقالات المفيدة .",
    description_En:"Here begins your journey to a deeper understanding of the Manafith platform from the perspective of the charitable association. On this page, you will find concise and rich articles that answer all your questions: What is Manafith? Why was it created? How does it work? And what is the added value? Along with some useful articles.",
    image:C_Hero_Image1,
    background:C_Hero1,
    background_dark:C_Hero_Image1_dark,
  },
  {
    id:2 ,
    smallTitle_Ar:"منذ 2011",
    smallTitle_En:"Since 2011",
    title_Ar:"تخصصنا",
    title_En:"We have specialized",
    subtitle_Ar:"لصرف المناولات والمساعدات",
    subtitle_En:"in disbursing handovers and aid",
    description_Ar:"هنا تبدأ رحلتك في فهم منصة منافذ بشكل أعمق، من وجهة نظر الجمعية الخيرية. ستجد في هذه الصفحة مقالات مختصرة وثرية تجيب عن كل ما يشغل بالك: ما هو منافذ ؟ لماذا تم إنشاؤه ؟ كيف يعمل ؟ وما القيمة المضافة ؟ مع بعض المقالات المفيدة .",
    description_En:"Here begins your journey to a deeper understanding of the Manafith platform from the perspective of the charitable association. On this page, you will find concise and rich articles that answer all your questions: What is Manafith? Why was it created? How does it work? And what is the added value? Along with some useful articles.",
    image:C_Hero_Image2,
    background:C_Hero2,
    background_dark:C_Hero_Image2_dark,
  },
  {
    id:3 ,
    smallTitle_Ar:"منذ 2011",
    smallTitle_En:"Since 2011",
    title_Ar:"أوجدنا الحلول",
    title_En:"We have found the solutions",
    subtitle_Ar:"لصرف المناولات والمساعدات",
    subtitle_En:"in disbursing handovers and aid",
    description_Ar:"هنا تبدأ رحلتك في فهم منصة منافذ بشكل أعمق، من وجهة نظر الجمعية الخيرية. ستجد في هذه الصفحة مقالات مختصرة وثرية تجيب عن كل ما يشغل بالك: ما هو منافذ ؟ لماذا تم إنشاؤه ؟ كيف يعمل ؟ وما القيمة المضافة ؟ مع بعض المقالات المفيدة .",
    description_En:"Here begins your journey to a deeper understanding of the Manafith platform from the perspective of the charitable association. On this page, you will find concise and rich articles that answer all your questions: What is Manafith? Why was it created? How does it work? And what is the added value? Along with some useful articles.",
    image:C_Hero_Image3,
    background:C_Hero3,
    background_dark:C_Hero_Image3_dark,
  },
 
]

export const C_Section2Data = [
  {
    id: 1,
    title_Ar: "لماذا صمم منافذ؟",
    title_En: "Why was Manafith designed?",
    description_Ar: `<p>في عام 2011، كانت معظم الجمعيات الخيرية تعتمد على وسائل تقليدية لصرف المساعدات، وهو ما شكّل عبئًا تشغيلياًو إداريًا كبيرًا، يؤدي  إلى ضعف التحكم و الرقابة و الشفافية، وصعوبة وصول الدعم للمستفيد بطريقة تحفظ كرامته.</p>
<p>من هنا، جاءت منصة منافذ كحل تقني مبتكر يُعيد تنظيم آلية صرف ومناولة المساعدات من خلال أدوات رقمية تُمكّن الجمعيات من:</p>
<ul>
<li><strong>تخفيف الأعباء التشغيلية والإدارية.</strong></li>
<li><strong>تقديم الدعم للمستفيدين بمرونة وكرامة.</strong></li>
<li><strong>تعزيز الحوكمة والرقابة اللحظية على المشاريع.</strong></li>
<li><strong>بناء شراكة فعالة بين القطاع الخيري والقطاع التجاري.</strong></li>
</ul>
<p>لقد صُمِّمَت منافذ لتقود التحول الحقيقي في أهم مرحلة في العمل الخيري: مرحلة وصول الدعم إلى المستفيد بطريقة تحفظ كرامته وتضمن كفاءته.</p>`,
    description_En: `<p>In 2011, most charitable associations relied on traditional methods for disbursing aid, which created a significant operational and administrative burden, leading to weak control, supervision, transparency, and difficulty in delivering support to beneficiaries in a way that preserves their dignity.</p>
<p>Hence, the Manafith platform emerged as an innovative technical solution that reorganizes the mechanism for disbursing and handling aid through digital tools that enable associations to:</p>
<ul>
<li><strong>Reduce operational and administrative burdens.</strong></li>
<li><strong>Provide support to beneficiaries flexibly and with dignity.</strong></li>
<li><strong>Enhance governance and real-time oversight of projects.</strong></li>
<li><strong>Build an effective partnership between the charitable and commercial sectors.</strong></li>
</ul>
<p>Manafith was designed to lead the real transformation in the most critical stage of charitable work: the stage where support reaches the beneficiary in a way that preserves their dignity and ensures its efficiency.</p>`,
image:qutionMarkImage
  },
  {
    id: 2,
    title_Ar: "ما هو منافذ ( بين قوسين )؟",
    title_En: "What is Manafith (in parentheses)?",
    description_Ar: `<p>(منافذ) هو نظام سعودي مبتكر يهدف إلى تطوير العمل الخيري من خلال تقديم حلول تقنية متكاملة لإدارة صرف ومناولة المساعدات. النظام يعمل كمنصة تقنية تربط الجمعيات الخيرية بالمتاجر ومزودي الخدمات بطريقة احترافية، مما يضمن تقديم المساعدات بكفاءة وشفافية.</p>
<p>أدوار منافذ بإيجاز:</p>
<ul>
<li><strong>(تنظيم الصرف)</strong>: يسهل إدارة صرف المساعدات المالية والعينية بطريقة دقيقة وموثقة.</li>
<li><strong>(تتبع المناولة)</strong>: يضمن وصول المساعدات للمستفيدين الفعليين مع إمكانية تتبع كل عملية.</li>
<li><strong>(الرقمنة والأتمتة)</strong>: يحوّل العمليات التقليدية إلى نظام رقمي مؤتمت لتقليل التكاليف وزيادة الكفاءة.</li>
<li><strong>(تعزيز الشفافية)</strong>: يقدم تقارير لحظية للجمعيات والجهات المانحة توضح حركة المساعدات.</li>
<li><strong>(قياس الأثر)</strong>: يساعد الجمعيات في تقييم أثر المساعدات ومدى تحقيق أهدافها.</li>
<li><strong>(ربط القطاعات)</strong>: يربط الجمعيات بمتاجر ومزودي خدمات متعددين لتوسيع الخيارات وتسهيل العمليات.</li>
<li><strong>(تعظيم الموارد)</strong>: يوفر خصومات واسترداد ضريبي للجمعيات، مما يزيد من قدرتها الشرائية.</li>
<li><strong>(حفظ كرامة المستفيدين)</strong>: يقدم المساعدات بطريقة تحترم كرامة المستفيد وتضمن سهولة وصوله لها دون تعقيدات.</li>
</ul>
<p><strong>الخلاصة</strong></p>
<p>منافذ ليس مجرد نظام تقني، بل هو منظومة شاملة تعمل على تمكين الجمعيات من تقديم خدماتها بأسلوب حديث وفعال، مع ضمان تحقيق أعلى أثر للمساعدات.</p>`,
    description_En: `<p>(Manafith) is an innovative Saudi system that aims to develop charitable work by providing integrated technical solutions for managing the disbursement and handling of aid. The system operates as a technical platform that connects charitable associations with stores and service providers in a professional manner, ensuring efficient and transparent delivery of assistance.</p>
<p>Brief roles of Manafith:</p>
<ul>
<li><strong>(Organizing Disbursement)</strong>: Facilitates the management of financial and in-kind aid disbursement in an accurate and documented manner.</li>
<li><strong>(Tracking Handling)</strong>: Ensures that aid reaches the actual beneficiaries with the ability to track every process.</li>
<li><strong>(Digitization and Automation)</strong>: Transforms traditional processes into an automated digital system to reduce costs and increase efficiency.</li>
<li><strong>(Enhancing Transparency)</strong>: Provides real-time reports to associations and donors showing the movement of aid.</li>
<li><strong>(Impact Measurement)</strong>: Helps associations evaluate the impact of aid and the extent to which their goals are achieved.</li>
<li><strong>(Sector Integration)</strong>: Connects associations with multiple stores and service providers to expand options and facilitate operations.</li>
<li><strong>(Resource Maximization)</strong>: Offers discounts and tax refunds to associations, increasing their purchasing power.</li>
<li><strong>(Preserving Beneficiary Dignity)</strong>: Provides aid in a way that respects the dignity of the beneficiary and ensures easy access without complications.</li>
</ul>
<p><strong>Conclusion</strong></p>
<p>Manafith is not just a technical system, but a comprehensive ecosystem that enables associations to provide their services in a modern and effective manner, while ensuring the highest impact of aid.</p>`,

},
{
  id: 3,
  title_Ar: "لماذا منافذ بالتحديد",
  title_En: "Why Manafith specifically",
  description_Ar: `<p>لأن منصة منافذ ليست مجرد فكرة أو مشروع ناشئ... بل نظام أثبت قدرته في الميدان لأكثر من عقد من الزمان.</p>
<p>منذ عام 2011، منافذ هي أول منصة في الشرق الأوسط متخصصة في صرف ومناولة المساعدات عبر ربط ذكي بين الجهات الخيرية والمستفيدين والمتاجر ومزودي الخدمات. لكنها لم تكتفِ بالسبق، بل بنت أقوى منظومة تشغيلية في القطاع الخيري واستمرت في التطور والتوسّع.</p>
<p>مع منافذ أنت تختار:</p>
<ul>
<li><strong>الأوسع انتشارًا</strong>: تخدم أكثر من 350 جمعية، وتتصل بـ 2542 نقطة بيع وخدمة في أنحاء المملكة العربية السعودية.</li>
<li><strong>الأكثر شمولية</strong>: تدير المشاريع من البدء وحتى التقييم، عبر أدوات تقنية ذكية وتقارير لحظية.</li>
<li><strong>الأقرب للمستفيد</strong>: تمنح المستفيد تجربة طبيعية تحاكي تجربة المتسوق العادي، بكرامة ومرونة.</li>
<li><strong>الأعلى موثوقية</strong>: معتمدة من قبل كبار المانحين وكبرى المتاجر والشركات، بل يُشترط استخدامها في عدد من مبادرات المنح.</li>
<li><strong>الأكثر مرونة</strong>: في بيئة التشغيل، تطويع التحديات، وإنشاء المسارات وتنفيذ المبادرات.</li>
</ul>
<p>منافذ ليست مجرد وسيط تقني يُصدر البطاقات أو القسائم...</p>
<p>بل شريك استراتيجي يُمكّن الجمعيات من التوسّع، وتقليل الأعباء، وتعظيم الأثر، ورفع كفاءة الأداء.</p>
<p>عندما تختار منافذ، فأنت تختار:</p>
<ul>
<li>• من صمّم الفكرة،</li>
<li>• ومن بنى النظام،</li>
<li>• ومن أثبت النجاح،</li>
<li>• ومن لا يزال يتطور ويتقدّم.</li>
</ul>`,
  description_En: `<p>Because the Manafith platform is not just an idea or a startup project... but a system that has proven its capability in the field for more than a decade.</p>
<p>Since 2011, Manafith has been the first platform in the Middle East specialized in disbursing and handling aid through smart connectivity between charitable organizations, beneficiaries, stores, and service providers. But it didn't stop at being first; it built the strongest operational system in the charitable sector and continues to evolve and expand.</p>
<p>With Manafith, you choose:</p>
<ul>
<li><strong>The most widespread</strong>: Serves over 350 associations and connects with 2,542 points of sale and service across Saudi Arabia.</li>
<li><strong>The most comprehensive</strong>: Manages projects from initiation to evaluation through smart technical tools and real-time reports.</li>
<li><strong>Closest to the beneficiary</strong>: Provides beneficiaries with a natural experience that mimics that of a regular shopper, with dignity and flexibility.</li>
<li><strong>The most reliable</strong>: Endorsed by major donors, large stores, and companies, and even required for use in several grant initiatives.</li>
<li><strong>The most flexible</strong>: In operational environments, adapting to challenges, creating pathways, and implementing initiatives.</li>
</ul>
<p>Manafith is not just a technical intermediary that issues cards or vouchers...</p>
<p>But a strategic partner that enables associations to expand, reduce burdens, maximize impact, and enhance performance efficiency.</p>
<p>When you choose Manafith, you choose:</p>
<ul>
<li>• The one who designed the idea,</li>
<li>• The one who built the system,</li>
<li>• The one who proved success,</li>
<li>• And the one who continues to evolve and advance.</li>
</ul>`
},
{
  id: 4,

    video:"https://youtu.be/kQnrM4gIw8M",
  image:video_Image

},
{
  id: 5,
  title_Ar: "كيف يعمل منافذ ببساطة؟",
  title_En: "How does Manafith work simply?",
  description_Ar: `<p>في منصة منافذ، لا حاجة للتخزين أو التوزيع أو متابعة الطوابير. المنصة تبسّط كل شيء، وتحوّل تشغيل المساعدات إلى تجربة رقمية سهلة ومنظّمة.</p>
<ol>
<li><strong>إطلاق المشروع</strong>:
<br>تبدأ الجمعية بتحديد نوع المشروع (كساء، غذاء، علاج، تعليم...) وتُدخل بياناته في المنصة، بما يشمل الميزانية، الفئة المستهدفة، والفترة الزمنية.</li>
<li><strong>اختيار المتاجر ومزودي الخدمات</strong>:
<br>تقوم الجمعية بتفعيل الشراكات المناسبة من شبكة المتاجر ومزودي الخدمات المنتشرين عبر المملكة، أو التعاقد مع جهات جديدة عبر المنصة.</li>
<li><strong>إنشاء البطاقات أو القسائم الشرائية</strong>:
<br>يتم إصدار بطاقات ذكية أو قسائم إلكترونية للمستفيدين، وربطها بالمشاريع المناسبة، مع إمكانية ربط البطاقة بأكثر من مشروع ومتجر في نفس الوقت.</li>
<li><strong>صرف المساعدات للمستفيدين</strong>:
<br>يستلم المستفيد البطاقة أو القسيمة إلكترونيًا، ويتوجّه لأقرب متجر أو مزود خدمة، ويستلم المساعدة بمرونة وكأنه متسوّق طبيعي.</li>
<li><strong>المتابعة والتوثيق</strong>:
<br>يتم توثيق جميع عمليات الصرف تلقائيًا عبر النظام، وتُعرض للجمعية تقارير لحظية شاملة عن حالة المشروع، ونسب الصرف، وتفاعل المستفيدين.</li>
<li><strong>الإقفال والتقارير</strong>:
<br>في نهاية المشروع، تقوم منصة منافذ بإصدار تقارير نهائية مالية وتشغيلية وإحصائية، تُمكّن الجمعية من تقديمها للجهات الإشرافية أو المانحة بسهولة واحترافية.</li>
</ol>
<p><strong>ببساطة</strong>:</p>
<p>منصة منافذ تختصر كل شيء:</p>
<ul>
<li>من إنشاء المشروع إلى صرف المساعدة،</li>
<li>من التعاقد مع المتاجر إلى استلام المستفيد،</li>
<li>من المتابعة إلى الإغلاق والتوثيق.</li>
</ul>
<p>كل ذلك عبر منظومة واحدة... رقمية، مرنة، وآمنة.</p>`,
  description_En: `<p>On the Manafith platform, there is no need for storage, distribution, or monitoring queues. The platform simplifies everything and transforms the operation of aid into an easy and organized digital experience.</p>
<ol>
<li><strong>Project Launch</strong>:
<br>The association starts by determining the type of project (clothing, food, treatment, education...) and enters its data into the platform, including the budget, target group, and time period.</li>
<li><strong>Selecting Stores and Service Providers</strong>:
<br>The association activates suitable partnerships from the network of stores and service providers spread across the kingdom, or contracts with new entities through the platform.</li>
<li><strong>Creating Cards or Purchase Vouchers</strong>:
<br>Smart cards or electronic vouchers are issued to beneficiaries and linked to appropriate projects, with the possibility of linking a card to more than one project and store at the same time.</li>
<li><strong>Disbursing Aid to Beneficiaries</strong>:
<br>The beneficiary receives the card or voucher electronically, goes to the nearest store or service provider, and receives assistance flexibly like a regular shopper.</li>
<li><strong>Monitoring and Documentation</strong>:
<br>All disbursement operations are automatically documented through the system, and the association is provided with comprehensive real-time reports on the project status, disbursement rates, and beneficiary interaction.</li>
<li><strong>Closure and Reports</strong>:
<br>At the end of the project, the Manafith platform issues final financial, operational, and statistical reports, enabling the association to present them to supervisory or donor entities easily and professionally.</li>
</ol>
<p><strong>Simply put</strong>:</p>
<p>The Manafith platform simplifies everything:</p>
<ul>
<li>From project creation to aid disbursement,</li>
<li>From contracting with stores to beneficiary receipt,</li>
<li>From monitoring to closure and documentation.</li>
</ul>
<p>All through one system... digital, flexible, and secure.</p>`
}
];

export const C_BlogsData=[
  {id:1,
    date:"22 June 2025",
    title_Ar: "ما هي الوحدات الإسنادية في منافذ؟",
    title_En: "What are the subsidiary units in Manafith?",
    description_Ar: `<p>في منصة منافذ، ندرك أن نجاح صرف المساعدات لا يتوقف عند إصدار بطاقة أو تشغيل متجر. لذا أنشأنا الوحدات الإسنادية كأذرع تخصصية، تساند الجمعية في جميع مراحل المشروع: قبل الإطلاق، أثناء التشغيل، وبعد الإغلاق.</p>
  
  <p>💡 <strong>ما دور الوحدات الإسنادية؟</strong></p>
  <p>كل وحدة تم تطويرها استجابة لاحتياج فعلي متكرر لدى الجمعيات، بدءًا من التخطيط وحتى قياس الأثر. هذه الوحدات لا تعمل بشكل منفصل عن المنصة، بل ترتبط بها تكامليًا وتضيف أبعادًا جديدة للعمل الخيري:</p>
  
  <p><strong>قبل تنفيذ الدعم:</strong></p>
  <ul>
  <li>دعم اتخاذ القرار عبر وحدة الاستبيانات.</li>
  <li>قياس جاهزية جميع الأطراف واستعدادهم.</li>
  </ul>
  
  <p><strong>أثناء تنفيذ الدعم:</strong></p>
  <ul>
  <li>تسهيل التواصل مع المستفيدين.</li>
  <li>إدارة المتابعة التشغيلية بدقة وتكامل.</li>
  <li>تقييم الرضا بشكل لحظي لاكتشاف الانحرافات والمعوقات والأخطاء.</li>
  <li>إشراك الأطراف الداعمة والمانحة والإشرافية لوضعهم في الصورة أولاً بأول.</li>
  </ul>
  
  <p><strong>بعد تنفيذ الدعم:</strong></p>
  <ul>
  <li>قياس الأثر الحقيقي من منظور المستفيد.</li>
  <li>توثيق النتائج وتقديمها للجهات الرقابية والمانحة باحترافية.</li>
  <li>إعداد تقارير مخصصة للجهات الداعمة عبر وحدة المانحين.</li>
  </ul>
  
  <p>🧭 <strong>خلاصة القول:</strong></p>
  <p>الوحدات الإسنادية ليست إضافة تجميلية، بل هي البنية التحتية الخفية التي تجعل مشاريع الجمعية أكثر نضجًا، وأعمق أثرًا، وأكثر قبولًا من الجهات المانحة والمشرفة.</p>
  <p>مع منافذ... كل وحدة تدعمك في مكانها المناسب، لتكون مشاريعك أكثر احترافية، وأقل عبئًا، وأكثر أثرًا.</p>`,
    description_En: `<p>At the Manafith platform, we understand that the success of aid disbursement does not stop at issuing a card or operating a store. Therefore, we have established support units as specialized arms that assist associations in all project stages: before launch, during operation, and after closure.</p>
  
  <p>💡 <strong>What is the role of the support units?</strong></p>
  <p>Each unit was developed in response to a real, recurring need among associations, from planning to impact measurement. These units do not operate separately from the platform but are integrally linked to it and add new dimensions to charitable work:</p>
  
  <p><strong>Before implementing support:</strong></p>
  <ul>
  <li>Supporting decision-making through the survey unit.</li>
  <li>Measuring the readiness and preparedness of all parties.</li>
  </ul>
  
  <p><strong>During support implementation:</strong></p>
  <ul>
  <li>Facilitating communication with beneficiaries.</li>
  <li>Managing operational follow-up with precision and integration.</li>
  <li>Assessing satisfaction in real-time to detect deviations, obstacles, and errors.</li>
  <li>Involving supporting, donor, and supervisory parties to keep them informed promptly.</li>
  </ul>
  
  <p><strong>After support implementation:</strong></p>
  <ul>
  <li>Measuring the real impact from the beneficiary's perspective.</li>
  <li>Documenting results and presenting them to regulatory and donor entities professionally.</li>
  <li>Preparing customized reports for supporting entities through the donor unit.</li>
  </ul>
  
  <p>🧭 <strong>In summary:</strong></p>
  <p>The support units are not just cosmetic additions but the hidden infrastructure that makes the association's projects more mature, impactful, and more acceptable to donors and supervisors.</p>
  <p>With Manafith... each unit supports you in its right place, making your projects more professional, less burdensome, and more impactful.</p>`,
    image: c_blog_image1,
    background: c_blog_Bg1,

  },
  {
    id: 2,
    date:"30 June 2025",
    title_Ar: "لماذا تنتقل الجمعيات إلى مزودي الخدمات؟",
    title_En: "Why are associations moving to service providers?",
    description_Ar: `<p>في السابق، كانت الجمعيات الخيرية تتولى بنفسها عملية صرف المساعدات: التخزين، التوزيع، التنسيق، المتابعة... لكن هذا الأسلوب التقليدي كان يستهلك طاقات الجمعية، يضاعف التكاليف، ويقلل الكفاءة.</p>
  <p>من هنا، جاءت فكرة منصة منافذ لتعيد تعريف أدوار الجهات الفاعلة في العمل الخيري. أحد أهم هذه التغييرات هو نقل تنفيذ المساعدات إلى مزودي الخدمات والمتاجر المتخصصة، لتقوم الجمعية بدورها الرقابي والتنسيقي فقط.</p>
  <p><strong>-- من هم مزودو الخدمات؟</strong></p>
  <p>هم المتاجر، الشركات، والمراكز المتخصصة التي تقدم سلعًا أو خدمات تتوافق مع نوع المساعدات التي تديرها الجمعية. ويشمل ذلك على سبيل المثال لا الحصر:</p>
  <ul>
  <li>المتاجر الغذائية (للسلال والمساعدات التموينية)</li>
  <li>محلات الملابس (للكساء وكسوة العيد)</li>
  <li>الصيدليات والمراكز الطبية (للمساعدات الصحية)</li>
  <li>المراكز التعليمية والتدريبية</li>
  <li>محلات الأدوات المنزلية والأجهزة</li>
  <li>شركات التوصيل</li>
  <li>المطاعم</li>
  <li>مراكز الترفيه</li>
  <li>مكاتب الاستشارات القانونية أو الأسرية... وغيرها</li>
  </ul>
  <p><strong>-- ما هو دورهم في دورة حياة صرف المساعدة؟</strong></p>
  <p>مزودو الخدمات في منصة منافذ لا يُعتبرون منفذين فقط، بل هم حلقة التشغيل الأساسية، ومن دونهم لا تكتمل دورة الصرف. وتشمل أدوارهم:</p>
  <ul>
  <li><strong>توفير الخدمة أو المنتج</strong>: يقدم مزود الخدمة السلع أو الخدمات المطلوبة للمستفيد بحسب نوع المساعدة (غذائية، صحية، كساء، استشارية، تعليمية...).</li>
  <li><strong>استقبال المستفيدين</strong>: يتعامل مع المستفيدين مباشرة بوسائل الدفع المعتمدة في منافذ (بطاقة، قسيمة، تطبيق...). يضمن تنفيذ الصرف بشكل إنساني واحترافي يشبه تجربة العميل العادي.</li>
  </ul>
  <p><strong>-- ما هي القيمة المضافة لمزودي الخدمات؟</strong></p>
  <p><strong>على جودة تنفيذ المشروع:</strong></p>
  <ul>
  <li>تنفيذ احترافي عبر متخصصين.</li>
  <li>خفض نسب الخطأ.</li>
  <li>سرع الإنجاز وسلاسة العمليات.</li>
  </ul>
  <p><strong>على المستفيد:</strong></p>
  <ul>
  <li>تجربة كريمة تشبه تجربة التسوّق المعتادة.</li>
  <li>تنوع الخيارات وتوفر الخدمات في منطقته.</li>
  </ul>
  <p><strong>على الجمعية:</strong></p>
  <ul>
  <li>التفرغ للأدوار الاستراتيجية والتنموية.</li>
  <li>إدارة مشاريع متعددة دون إرهاق إداري أو ميداني.</li>
  <li>تقليل المخاطر المتعلقة في إدارة السلع و حفظها و عنايتها.</li>
  </ul>
  <p><strong>الخلاصة:</strong></p>
  <p>مزودو الخدمات هم الشريك التنفيذي للجمعيات داخل منصة منافذ. وجودهم ليس فقط ضرورة تشغيلية، بل هو تحوّل في منهج العمل الخيري، من التوزيع اليدوي إلى منظومة احترافية تتكامل فيها الجمعيات مع السوق لخدمة المستفيد بكرامة، وفعالية، وشفافية.</p>`,
    description_En: `<p>Previously, charitable associations used to handle the process of disbursing aid themselves: storage, distribution, coordination, follow-up... But this traditional approach consumed the association's energy, doubled costs, and reduced efficiency.</p>
  <p>Hence, the idea of the Manafith platform came to redefine the roles of actors in charitable work. One of the most important changes is transferring the implementation of aid to service providers and specialized stores, allowing the association to focus only on supervisory and coordination roles.</p>
  <p><strong>-- Who are the service providers?</strong></p>
  <p>They are stores, companies, and specialized centers that offer goods or services that align with the type of aid managed by the association. This includes, but is not limited to:</p>
  <ul>
  <li>Grocery stores (for food baskets and supplies)</li>
  <li>Clothing stores (for clothing and holiday attire)</li>
  <li>Pharmacies and medical centers (for health aid)</li>
  <li>Educational and training centers</li>
  <li>Household goods and appliance stores</li>
  <li>Delivery companies</li>
  <li>Restaurants</li>
  <li>Entertainment centers</li>
  <li>Legal or family consulting offices... and others</li>
  </ul>
  <p><strong>-- What is their role in the aid disbursement lifecycle?</strong></p>
  <p>Service providers on the Manafith platform are not just implementers; they are the core operational link, and without them, the disbursement cycle cannot be completed. Their roles include:</p>
  <ul>
  <li><strong>Providing the service or product</strong>: The service provider offers the required goods or services to the beneficiary according to the type of aid (food, health, clothing, consulting, educational, etc.).</li>
  <li><strong>Receiving beneficiaries</strong>: They interact directly with beneficiaries using the payment methods approved by Manafith (card, voucher, app, etc.). They ensure that disbursement is carried out in a humane and professional manner, similar to a regular customer experience.</li>
  </ul>
  <p><strong>-- What is the added value of service providers?</strong></p>
  <p><strong>On project execution quality:</strong></p>
  <ul>
  <li>Professional execution through specialists.</li>
  <li>Reduced error rates.</li>
  <li>Faster completion and smoother operations.</li>
  </ul>
  <p><strong>On the beneficiary:</strong></p>
  <ul>
  <li>A dignified experience similar to regular shopping.</li>
  <li>Diverse options and availability of services in their area.</li>
  </ul>
  <p><strong>On the association:</strong></p>
  <ul>
  <li>Focus on strategic and developmental roles.</li>
  <li>Manage multiple projects without administrative or field fatigue.</li>
  <li>Reduce risks related to managing, storing, and maintaining goods.</li>
  </ul>
  <p><strong>Conclusion:</strong></p>
  <p>Service providers are the executive partners of associations within the Manafith platform. Their presence is not just an operational necessity but a transformation in the methodology of charitable work—from manual distribution to a professional system where associations integrate with the market to serve beneficiaries with dignity, efficiency, and transparency.</p>`,
  image: c_blog_image2,
  background: c_blog_Bg2,
  },
  {
    id: 3,
    date:"31 June 2025",
    title_Ar: "القيمة المضافة لمنافذ",
    title_En: "Added value to Manafith",
    description_Ar: `<p>القيمة المضافة التي تحققها الجمعيات الخيرية عند استخدام منصة منافذ: استخدام الجمعيات لمنصة منافذ لا يعني فقط أداة تقنية، بل انتقال حقيقي إلى مستوى أعلى من الكفاءة والأثر. القيمة المضافة تتجلى في المحاور التالية:</p>
  <ol>
  <li><strong>تحوّل في الدور التشغيلي</strong>
  <br>تنتقل الجمعية من تنفيذ المساعدة بشكل مباشر إلى دور إشرافي وتنظيمي، مما يقلل الأعباء الميدانية، ويوفر وقت وجهد الفريق، ويمنحها قدرة على التركيز على التطوير والاستدامة.</li>
  <li><strong>تعزيز الحوكمة والمصداقية</strong>
  <br>كل عملية تتم عبر النظام موثقة ومحفوظة، ما يوفّر تقارير لحظية يمكن مشاركتها مع المانحين والجهات الرقابية، ويمنح الجمعيات ثقة أكبر في طلبات الدعم والتمويل.</li>
  <li><strong>رفع كفاءة الصرف وتحقيق عدالة الوصول</strong>
  <br>يستلم المستفيد دعمه بشكل مباشر من المتجر، بخيارات متعددة وبدون ازدحام أو انتقائية، مما يضمن وصول الدعم بأفضل صورة ممكنة، ويعزز الشعور بالكرامة.</li>
  <li><strong>توفير مالي وتشغيلي ملموس</strong>
  <br>من خلال دمج المتاجر ومزودي الخدمات، تستفيد الجمعية من خصومات مضافة، واسترداد ضريبي، وتوفير كبير في التكاليف التشغيلية (نقل، تخزين، موظفين، وقت...).</li>
  <li><strong>قياس وتحسين مستمر للأثر</strong>
  <br>توفر المنصة أدوات دقيقة لقياس رضا المستفيدين وفعالية البرامج، مما يساعد الجمعيات على تحسين مشاريعها باستمرار وتقديم تقارير أكثر عمقًا للمانحين.</li>
  <li><strong>مرونة عالية في تصميم وتفعيل المشاريع</strong>
  <br>منافذ تتيح للجمعيات تصميم مشاريع متنوعة (غذاء، كساء، علاج، تعليم...) وربطها مع مزودي خدمات مختلفين، مما يعطي مرونة كاملة في الاستجابة للاحتياج الفعلي.</li>
  </ol>
  <p><strong>الخلاصة:</strong></p>
  <p>القيمة الحقيقية لـ منافذ تكمن في أنها تمكّن الجمعية من أن تكون أكثر تنظيمًا، أقل عبئًا، أكثر شفافية، وأعلى أثرًا… وهذا ما يصنع الفرق في العمل الخيري.</p>`,
    description_En: `<p>The added value that charitable associations achieve when using the Manafith platform: Using the Manafith platform is not just a technical tool for associations, but a real transition to a higher level of efficiency and impact. The added value is evident in the following aspects:</p>
  <ol>
  <li><strong>Transformation in Operational Role</strong>
  <br>The association shifts from direct implementation of aid to a supervisory and organizational role, reducing field burdens, saving team time and effort, and enabling focus on development and sustainability.</li>
  <li><strong>Enhanced Governance and Credibility</strong>
  <br>Every operation through the system is documented and preserved, providing real-time reports that can be shared with donors and regulatory bodies, giving associations greater confidence in support and funding requests.</li>
  <li><strong>Improved Disbursement Efficiency and Fair Access</strong>
  <br>Beneficiaries receive their support directly from stores, with multiple options and without crowding or selectivity, ensuring that aid reaches them in the best possible way and enhancing the sense of dignity.</li>
  <li><strong>Tangible Financial and Operational Savings</strong>
  <br>By integrating stores and service providers, associations benefit from additional discounts, tax refunds, and significant savings in operational costs (transportation, storage, staff, time...).</li>
  <li><strong>Continuous Impact Measurement and Improvement</strong>
  <br>The platform provides accurate tools to measure beneficiary satisfaction and program effectiveness, helping associations continuously improve their projects and provide more in-depth reports to donors.</li>
  <li><strong>High Flexibility in Designing and Activating Projects</strong>
  <br>Manafith allows associations to design diverse projects (food, clothing, treatment, education...) and link them with different service providers, providing complete flexibility in responding to actual needs.</li>
  </ol>
  <p><strong>Conclusion:</strong></p>
  <p>The true value of Manafith lies in enabling associations to be more organized, less burdened, more transparent, and higher impact... This is what makes the difference in charitable work.</p>`,
  image: c_blog_image3,
  background: c_blog_Bg3,
  },
  {
    id: 4,
    date:"10 may 2025",
    title_Ar: "ما هي المساعدات والخدمات التي يمكن صرفها عبر منافذ وكيف تصرف",
    title_En: "What are the aids and services that can be disbursed through Manafith and how are they disbursed",
    description_Ar: `<p>توفر منصة منافذ مرونة عالية للجمعيات الخيرية في تصميم وتخصيص بطاقات أو قسائم الدعم بحسب احتياجات المستفيدين، مع إمكانية صرف المساعدات العينية والخدمات النوعية ضمن ضوابط تتحكم بالمرونة والتقييد.</p>
  <p><strong>أولًا: المساعدات العينية</strong></p>
  <p>تشمل جميع أنواع المواد والسلع التي تُقدَّم للمستفيدين من قبل متاجر أو مزودي خدمات لتغطية احتياجاتهم الأساسية، مثل:</p>
  <ul>
  <li>المواد الغذائية</li>
  <li>الكساء</li>
  <li>الأجهزة المنزلية</li>
  <li>الأدوية</li>
  <li>المستلزمات الطبية</li>
  <li>وغيرها من السلع</li>
  </ul>
  <p><strong>ثانيًا: الخدمات</strong></p>
  <p>لا تقتصر منصة منافذ على السلع، بل تدعم صرف الخدمات التي تسهم في تحسين جودة حياة المستفيدين تقدم من خلال مزودي خدمات متخصصين، ومنها:</p>
  <ul>
  <li>الخدمات الطبية</li>
  <li>الخدمات التعليمية</li>
  <li>الخدمات القانونية والاستشارية</li>
  <li>الخدمات الترفيهية والاجتماعية</li>
  </ul>
  <p><strong>أنواع الارصدة في منصة منافذ</strong></p>
  <p>نظرًا لتنوع طبيعة المشاريع في الجمعيات الخيرية، تقدم منافذ خيارات متعددة لآلية صرف الدعم، بما يتيح للجمعية تنفيذ مشاريع:</p>
  <ul>
  <li>إغاثية</li>
  <li>تنموية</li>
  <li>إسنادية</li>
  <li>شعائر دينية مقيدة بأصناف أو أوقات</li>
  </ul>
  <p>ويمكن شحن بطاقات المستفيدين أو إصدار قسائم شرائية تحتوي على:</p>
  <ul>
  <li><strong>قيمة مالية</strong>: تُستخدم في شراء السلع أو الخدمات من مزود الخدمة المعتمد</li>
  <li><strong>كمية محددة من سلعة أو خدمة</strong>: تُستخدم لاستلام خدمة أو صنف محدد دون تغييره</li>
  </ul>
  <p><strong>مثال توضيحي:</strong></p>
  <p>يمكن شحن بطاقة غذائية بقيمة 100 ريال، أو شحنها بـ 2 كيس رز.</p>
  <ul>
  <li>في الحالة الأولى: يختار المستفيد ما يشاء من السلع لدى مزود الخدمة</li>
  <li>في الحالة الثانية: يستلم فقط 2 كيس رز كما حُدد بالصنف والنوع، دون إمكانية استبدالهما</li>
  </ul>
  <p><strong>- لماذا هذا التنوع مهم؟</strong></p>
  <p>يوفر هذا التنوع في أنواع الرصيد للجمعيات:</p>
  <ul>
  <li>إمكانية إطلاق مشاريع مخصصة لتوفير سلع أو خدمات بعينها</li>
  <li>تنفيذ شعائر دينية أو متطلبات مانحين بدقة واحترافية</li>
  </ul>`,
    description_En: `<p>The Manafith platform provides high flexibility for charitable associations to design and customize support cards or vouchers according to beneficiaries' needs, with the ability to disburse in-kind aid and specialized services within controls that balance flexibility and restrictions.</p>
  <p><strong>First: In-kind Assistance</strong></p>
  <p>Includes all types of materials and goods provided to beneficiaries by stores or service providers to cover their basic needs, such as:</p>
  <ul>
  <li>Food items</li>
  <li>Clothing</li>
  <li>Household appliances</li>
  <li>Medicines</li>
  <li>Medical supplies</li>
  <li>Other goods</li>
  </ul>
  <p><strong>Second: Services</strong></p>
  <p>The Manafith platform is not limited to goods; it also supports the disbursement of services that contribute to improving beneficiaries' quality of life, provided through specialized service providers, including:</p>
  <ul>
  <li>Medical services</li>
  <li>Educational services</li>
  <li>Legal and consulting services</li>
  <li>Recreational and social services</li>
  </ul>
  <p><strong>Types of Balances in the Manafith Platform</strong></p>
  <p>Given the diverse nature of projects in charitable associations, Manafith offers multiple options for support disbursement mechanisms, enabling associations to implement:</p>
  <ul>
  <li>Relief projects</li>
  <li>Developmental projects</li>
  <li>Support projects</li>
  <li>Religious rituals restricted by items or times</li>
  </ul>
  <p>Beneficiary cards can be loaded or purchase vouchers issued containing:</p>
  <ul>
  <li><strong>Monetary value</strong>: Used to purchase goods or services from approved service providers</li>
  <li><strong>Specific quantity of a good or service</strong>: Used to receive a specific service or item without change</li>
  </ul>
  <p><strong>Illustrative Example:</strong></p>
  <p>A food card can be loaded with 100 riyals or with 2 bags of rice.</p>
  <ul>
  <li>In the first case: The beneficiary chooses whatever goods they want from the service provider</li>
  <li>In the second case: They receive only 2 bags of rice as specified by type and kind, without the possibility of substitution</li>
  </ul>
  <p><strong>- Why is this diversity important?</strong></p>
  <p>This diversity in balance types provides associations with:</p>
  <ul>
  <li>The ability to launch customized projects to provide specific goods or services</li>
  <li>Implementation of religious rituals or donor requirements with precision and professionalism</li>
  </ul>`,
  image: c_blog_image4,
  background: c_blog_Bg4,
  },
  {
    id: 5,
    date:"15 may 2025",
    title_Ar: "ما هي مخرجات نظام منافذ",
    title_En: "What are the outputs of the Manafith system",
    description_Ar: `<p>منافذ ليس مجرد نظام لإدارة صرف المساعدات، بل هو منظومة تنتج مخرجات ملموسة ونتائج مؤثرة تمتد آثارها إلى الجمعيات الخيرية، المستفيدين، المجتمع، والجهات الرقابية. المخرجات يمكن تلخيصها في النقاط التالية:</p>
  <p><strong>1. مخرجات ملموسة:</strong></p>
  <ul>
  <li><strong>كشوف مشتريات المستفيدين بدقة وسرعة</strong>: تفاصيل دقيقة توضح مشتريات المستفيدين (المبالغ، الأصناف، التوقيت).</li>
  <li><strong>تسويات شهرية شفافة</strong>: تسويات شفافة بين الجمعيات ومزودي الخدمات مبنية على قيمة الاستفادة الحقيقية.</li>
  <li><strong>تقارير رقمية مباشرة</strong>: توثق كل عملية صرف ومناولة بدقة، مما يتيح تقارير مباشرة عن الوضع بشفافية.</li>
  </ul>
  <p><strong>2. نتائج تؤثر على الجمعيات:</strong></p>
  <ul>
  <li><strong>تقليل التكاليف</strong>: توفير الوقت والجهد وتقليل العمليات التقليدية.</li>
  <li><strong>رفع الكفاءة</strong>: تحسين إدارة المساعدات وزيادة دقة التوزيع.</li>
  <li><strong>تعزيز الشفافية</strong>: تقارير دقيقة تدعم بناء الثقة مع المانحين والمجتمع.</li>
  </ul>
  <p><strong>3. نتائج تؤثر على المستفيدين:</strong></p>
  <ul>
  <li><strong>حفظ الكرامة</strong>: حصول المستفيدين على المساعدات بأسلوب حضاري يحترم خصوصيتهم.</li>
  <li><strong>زيادة الرضا</strong>: مرونة الصرف حيث يمكن للمستفيد الشراء أو الاستلام من عدة متاجر مع حرية اختيار السلع المناسبة له.</li>
  <li><strong>تخفيف الأعباء</strong>: الوصول السريع للمتاجر ومزودي الخدمات المنتشرين دون الحاجة للحضور للجمعية.</li>
  </ul>
  <p><strong>4. نتائج تؤثر على المجتمع:</strong></p>
  <ul>
  <li><strong>الأثر المجتمعي</strong>: المساهمة في حل مشاكل المستفيدين والارتقاء بالمجتمع بأسلوب حضاري.</li>
  <li><strong>تعزيز التعاون</strong>: دعم الشراكات بين الجمعيات ومزودي الخدمات لتحقيق تنمية مستدامة وخلق تحالفات شرائية بين الجمعيات للحصول على أكبر مكتسبات من القطاع الخاص.</li>
  </ul>
  <p><strong>الخلاصة:</strong></p>
  <p>مخرجات منافذ تتجاوز تقديم المساعدات لتشمل تحسين الأداء، تعزيز الشفافية، وزيادة الأثر الإيجابي للمساعدات. النظام يساهم في بناء مجتمع أفضل عبر حلول تقنية حديثة تخدم جميع الأطراف بكفاءة واحترافية.</p>`,
    description_En: `<p>Manafith is not just a system for managing aid disbursement; it is an ecosystem that produces tangible outputs and impactful results that extend to charitable associations, beneficiaries, society, and regulatory bodies. The outputs can be summarized in the following points:</p>
  <p><strong>1. Tangible Outputs:</strong></p>
  <ul>
  <li><strong>Accurate and fast beneficiary purchase statements</strong>: Detailed information showing beneficiaries' purchases (amounts, items, timing).</li>
  <li><strong>Transparent monthly settlements</strong>: Transparent settlements between associations and service providers based on actual usage value.</li>
  <li><strong>Direct digital reports</strong>: Precisely document every disbursement and handling process, enabling real-time transparent status reports.</li>
  </ul>
  <p><strong>2. Results Impacting Associations:</strong></p>
  <ul>
  <li><strong>Cost reduction</strong>: Saving time and effort while reducing traditional processes.</li>
  <li><strong>Efficiency improvement</strong>: Enhancing aid management and increasing distribution accuracy.</li>
  <li><strong>Transparency enhancement</strong>: Accurate reports that support building trust with donors and society.</li>
  </ul>
  <p><strong>3. Results Impacting Beneficiaries:</strong></p>
  <ul>
  <li><strong>Preserving dignity</strong>: Beneficiaries receive aid in a civilized manner that respects their privacy.</li>
  <li><strong>Increased satisfaction</strong>: Flexible disbursement allowing beneficiaries to purchase or receive from multiple stores with freedom to choose suitable goods.</li>
  <li><strong>Reduced burdens</strong>: Quick access to widespread stores and service providers without needing to visit the association.</li>
  </ul>
  <p><strong>4. Results Impacting Society:</strong></p>
  <ul>
  <li><strong>Societal impact</strong>: Contributing to solving beneficiaries' problems and elevating society in a civilized manner.</li>
  <li><strong>Enhanced cooperation</strong>: Supporting partnerships between associations and service providers to achieve sustainable development and create purchasing alliances among associations to gain maximum benefits from the private sector.</li>
  </ul>
  <p><strong>Conclusion:</strong></p>
  <p>Manafith's outputs go beyond providing aid to include performance improvement, transparency enhancement, and increased positive impact of assistance. The system contributes to building a better society through modern technical solutions that serve all parties efficiently and professionally.</p>`,
  image: c_blog_image5,
  background: c_blog_Bg5,
  },
  {
    id: 6,
    date:"17 may 2025",
    title_Ar: "تساؤولات عن منافذ",
    title_En: "Questions about Manafith",
    description_Ar: `<p><strong>هل منافذ مناسبة لجمعيتي، حتى لو كانت صغيرة أو في منطقة محدودة؟</strong><br>
  نعم، منافذ تخدم أكثر من 350 جمعية من مختلف الأحجام والمناطق، وتوفر مرونة تامة في التنفيذ حسب قدرات الجمعية واحتياجاتها.</p>
  <p><strong>هل أحتاج إلى بنية تقنية متقدمة للتعامل مع منافذ؟</strong><br>
  لا، منصة منافذ صُمّمت لتكون سهلة الاستخدام، ولا تتطلب أي تجهيزات تقنية معقدة. فريق الدعم في منافذ يرافق الجمعية خطوة بخطوة حتى تصبح جاهزة للعمل بكفاءة.</p>
  <p><strong>هل سأتخلى عن السيطرة على المشروع لصالح المتاجر؟</strong><br>
  بالعكس، منافذ تمنح الجمعية تحكمًا كاملًا في تنفيذ المشروع. الجمعية هي من تصمم المشروع وتحدد الميزانية ونوع المساعدة والشروط، بينما منافذ تنفذ حسب هذه الضوابط.</p>
  <p><strong>كيف أضمن وصول المساعدة فعليًا للمستفيد؟</strong><br>
  منافذ لا تكتفي بالصرف، بل توثق المناولة بدقة. يمكنك تتبع كل عملية، ومعرفة من استفاد، ومتى، ومن أي متجر، وتصدر تقارير فورية لكل ما يحدث.</p>
  <p><strong>هل يمكنني تقديم مساعدات متنوعة في نفس المشروع؟</strong><br>
  نعم، يمكن شحن بطاقة واحدة بأكثر من نوع رصيد (غذاء، كساء، خدمات)، وتفعيلها على عدة متاجر في وقت واحد. وهذا يمنح المستفيد تجربة مرنة وغنية.</p>
  <p><strong>هل تتوافق منافذ مع متطلبات المانحين والجهات الرقابية؟</strong><br>
  تمامًا، العديد من المانحين يشترطون استخدام منافذ لتنفيذ المشاريع؛ لما توفره من تقارير دقيقة وشفافية عالية وضمانات في صرف الدعم.</p>
  <p><strong>هل الدعم الفني متوفر؟ وماذا لو واجهت صعوبات؟</strong><br>
  فريق منافذ موجود دائمًا لخدمتك، بدءًا من الإعداد وحتى الإغلاق. وهناك أدوات تفاعلية واستشارات مباشرة للتأكد من نجاح المشروع بأفضل صورة.</p>
  <p><strong>ما الفرق الحقيقي بين منافذ وبين توزيع المساعدات بالطريقة التقليدية؟</strong><br>
  الفرق شاسع. مع منافذ، تنتقل الجمعية من نموذج "تجميع – تخزين – توزيع" إلى نموذج "تصميم – تفعيل – رقابة". الكفاءة أعلى، والجهد أقل، والأثر أوسع.</p>`,
    description_En: `<p><strong>Is Manafith suitable for my association, even if it's small or in a limited area?</strong><br>
  Yes, Manafith serves over 350 associations of various sizes and regions, providing complete flexibility in implementation according to the association's capabilities and needs.</p>
  
  <p><strong>Do I need advanced technical infrastructure to work with Manafith?</strong><br>
  No, the Manafith platform is designed to be user-friendly and does not require any complex technical setups. Manafith's support team accompanies the association step by step until it's ready to operate efficiently.</p>
  
  <p><strong>Will I lose control over the project to the stores?</strong><br>
  On the contrary, Manafith gives the association full control over project implementation. The association designs the project, sets the budget, determines the type of assistance and conditions, while Manafith executes according to these controls.</p>
  
  <p><strong>How can I ensure that the aid actually reaches the beneficiary?</strong><br>
  Manafith doesn't just disburse; it precisely documents the handling. You can track every transaction, know who benefited, when, and from which store, and receive instant reports on everything that happens.</p>
  
  <p><strong>Can I provide various types of assistance in the same project?</strong><br>
  Yes, a single card can be loaded with multiple types of balances (food, clothing, services) and activated at several stores simultaneously. This gives the beneficiary a flexible and rich experience.</p>
  
  <p><strong>Is Manafith compliant with donor and regulatory requirements?</strong><br>
  Absolutely, many donors require the use of Manafith for project implementation due to the accurate reports, high transparency, and guarantees in aid disbursement it provides.</p>
  
  <p><strong>Is technical support available? What if I face difficulties?</strong><br>
  Manafith's team is always available to serve you, from setup to closure. There are interactive tools and direct consultations to ensure the project's success in the best possible way.</p>
  
  <p><strong>What is the real difference between Manafith and traditional aid distribution methods?</strong><br>
  The difference is vast. With Manafith, associations transition from a "collect-store-distribute" model to a "design-activate-supervise" model. Efficiency is higher, effort is lower, and impact is broader.</p>`,
  image: c_blog_image6,
  background: c_blog_Bg6,
  },
  {
    id: 7,
    date:"22 may 2025",
    title_Ar: "تعظيم الأثر في منافذ",
    title_En: "Maximizing Impact in Manafith",
    description_Ar: `<p>في منافذ، تعظيم الأثر ليس مجرد فلسفة، بل هي عمل حقيقي يطبق على جميع مراحل إدارة المساعدات والخدمات. النظام يعمل على تحقيق الاستفادة القصوى من الموارد المالية للجمعية وعبرها يتم استثمار صرف المساعدات في تحقيق عدة استثمارات ومنها.</p>
  
  <p><strong>مسارات تعظيم الأثر في منافذ:</strong></p>
  
  <p><strong>1. الأثر المالي:</strong></p>
  <ul>
  <li><strong>الخصومات والامتيازات</strong>: منافذ يمكّن الجمعيات من التفاوض مع المتاجر ومزودي الخدمات للحصول على خصومات مجزية، مما يعزز القدرة الشرائية للجمعيات.</li>
  <li><strong>استرداد الضريبة</strong>: النظام يدعم توفير مستوجبات استرداد الضريبة، مما يحقق للجمعيات عوائد مالية إضافية.</li>
  </ul>
  
  <p><strong>2. الأثر غير المالي:</strong></p>
  <ul>
  <li><strong>توظيف المستفيدين</strong>: الجمعيات بالتعاون مع المتاجر تُشجع على توظيف بعض المستفيدين كجزء من الشراكة المجتمعية.</li>
  <li><strong>دعم الأسر المنتجة</strong>: يتيح النظام عرض وبيع منتجات الأسر المنتجة في المتاجر، مما يدعم الاستدامة المالية لهذه الأسر.</li>
  <li><strong>الترويج للجمعيات</strong>: المتاجر المتعاقدة مع الجمعيات تسهم في نشر برامج ومشاريع الجمعيات عبر قنواتها التسويقية، مما يعزز الوعي بدور الجمعيات.</li>
  </ul>
  
  <p><strong>الخلاصة:</strong></p>
  <p>في منافذ، تعظيم الأثر يعني تحويل كل ريال وكل مورد إلى نتائج حقيقية تسهم في تحسين حياة المستفيدين ورفع كفاءة العمل الخيري. بفضل أساليبه المبتكرة، يتيح النظام للجمعيات تعظيم الأثر المالي وغير المالي، مما يحقق تنمية مستدامة للمجتمع ككل.</p>`,
    description_En: `<p>In Manafith, impact maximization is not just a philosophy, but a real practice applied across all stages of managing aid and services. The system works to achieve the maximum benefit from the association's financial resources, and through it, aid disbursement is invested in achieving multiple investments.</p>
  
  <p><strong>Pathways for Impact Maximization in Manafith:</strong></p>
  
  <p><strong>1. Financial Impact:</strong></p>
  <ul>
  <li><strong>Discounts and Privileges</strong>: Manafith enables associations to negotiate with stores and service providers to obtain rewarding discounts, enhancing the purchasing power of associations.</li>
  <li><strong>Tax Refund</strong>: The system supports providing tax refund entitlements, achieving additional financial returns for associations.</li>
  </ul>
  
  <p><strong>2. Non-Financial Impact:</strong></p>
  <ul>
  <li><strong>Employing Beneficiaries</strong>: Associations, in cooperation with stores, encourage the employment of some beneficiaries as part of community partnership.</li>
  <li><strong>Supporting Productive Families</strong>: The system allows displaying and selling products of productive families in stores, supporting the financial sustainability of these families.</li>
  <li><strong>Promoting Associations</strong>: Stores contracted with associations contribute to spreading the programs and projects of associations through their marketing channels, enhancing awareness of the role of associations.</li>
  </ul>
  
  <p><strong>Conclusion:</strong></p>
  <p>In Manafith, impact maximization means transforming every riyal and every resource into real results that contribute to improving the lives of beneficiaries and enhancing the efficiency of charitable work. Thanks to its innovative methods, the system enables associations to maximize both financial and non-financial impact, achieving sustainable development for the entire society.</p>`,
  image: c_blog_image7,
  background: c_blog_Bg7,
  },
  {
    id: 8,
    date:"28 June 2025",
    title_Ar: "الجمعيات في منظور منافذ",
    title_En: "Associations in the Perspective of Manafith",
    description_Ar: `<p>في بيئة مستقرة وآمنة كالمملكة العربية السعودية، حيث تتوفر الموارد وتنتشر المتاجر والخدمات في معظم المناطق، ترى منصة منافذ أن الدور الحقيقي للجمعيات الخيرية لا يتمثل في شراء السلع أو تخزينها أو توزيعها بشكل مباشر، بل في ممارسة مسؤولياتها الجوهرية بوصفها كيانات مجتمعية تُعنى بتحديد الاحتياج وتوجيه الموارد نحو الأثر.</p>
  
  <p>وفق هذا المنظور، يُعاد تعريف دور الجمعية على النحو التالي:</p>
  <ul>
  <li><strong>دراسة الحالة المجتمعية</strong>: عبر التخصص الوظيفي للجمعية (أيتام، أرامل، فقراء، معاقين،... إلخ)، وتحليل الفجوات الفعلية لدى الفئة المستهدفة.</li>
  <li><strong>تصميم البرامج والمبادرات</strong>: من خلال بناء حلول تنموية أو إغاثية أو وقائية بناءً على التحليل الميداني.</li>
  <li><strong>تأمين التمويل</strong>: سواء من التبرعات، أو الجهات المانحة، أو من ريع المشاريع الخاصة بالجمعية.</li>
  <li><strong>إدارة تنفيذ المشروع</strong>: دون الانشغال بالأعمال التشغيلية المباشرة، بل عبر توظيف الشراكات مع مزودي الخدمات والمتاجر لتنفيذ الدعم باحترافية.</li>
  <li><strong>قياس الأثر والتحسين</strong>: من خلال أدوات رقمية موثوقة لقياس رضا المستفيدين، وجودة التنفيذ، ومستوى تحقق الأهداف.</li>
  </ul>
  
  <p><strong>الخلاصة:</strong></p>
  <p>منافذ تدعو الجمعيات إلى إعادة التمركز نحو دورها الحقيقي: التحليل، والتخطيط، والتمويل، والرقابة، والتطوير.</p>
  <p>أما مهام التشغيل والمناولة، فهي مسؤولية السوق المحلي من متاجر ومزودي خدمات، ضمن منظومة رقمية تضمن أعلى درجات الحوكمة، والكفاءة، وكرامة المستفيد.</p>
  <p>بهذا، تصبح الجمعيات أكثر قدرة على التوسع، أكثر تركيزًا على رسالتها، وأكثر تأثيرًا في المجتمع.</p>`,
    description_En: `<p>In a stable and secure environment like Saudi Arabia, where resources are available and stores and services are widespread in most regions, the Manafith platform believes that the true role of charitable associations is not to purchase, store, or distribute goods directly, but to exercise their core responsibilities as community entities concerned with identifying needs and directing resources toward impact.</p>
  
  <p>According to this perspective, the role of the association is redefined as follows:</p>
  <ul>
  <li><strong>Studying the Community Situation</strong>: Through the functional specialization of the association (orphans, widows, the poor, people with disabilities, etc.), and analyzing the actual gaps among the target group.</li>
  <li><strong>Designing Programs and Initiatives</strong>: By building developmental, relief, or preventive solutions based on field analysis.</li>
  <li><strong>Securing Funding</strong>: Whether from donations, donor entities, or revenue from the association's own projects.</li>
  <li><strong>Managing Project Implementation</strong>: Without being preoccupied with direct operational tasks, but by leveraging partnerships with service providers and stores to implement support professionally.</li>
  <li><strong>Measuring Impact and Improvement</strong>: Through reliable digital tools to measure beneficiary satisfaction, quality of implementation, and achievement of objectives.</li>
  </ul>
  
  <p><strong>Conclusion:</strong></p>
  <p>Manafith calls on associations to reposition themselves toward their true role: analysis, planning, funding, supervision, and development.</p>
  <p>As for operational and handling tasks, they are the responsibility of the local market of stores and service providers, within a digital system that ensures the highest levels of governance, efficiency, and beneficiary dignity.</p>
  <p>Thus, associations become more capable of expansion, more focused on their mission, and more impactful in society.</p>`,
  image: c_blog_image8,
  background: c_blog_Bg8,
  },

    {
    id: 2,
    date:"30 June 2025",
    title_Ar: "لماذا تنتقل الجمعيات إلى مزودي الخدمات؟",
    title_En: "Why are associations moving to service providers?",
    description_Ar: `<p>في السابق، كانت الجمعيات الخيرية تتولى بنفسها عملية صرف المساعدات: التخزين، التوزيع، التنسيق، المتابعة... لكن هذا الأسلوب التقليدي كان يستهلك طاقات الجمعية، يضاعف التكاليف، ويقلل الكفاءة.</p>
  <p>من هنا، جاءت فكرة منصة منافذ لتعيد تعريف أدوار الجهات الفاعلة في العمل الخيري. أحد أهم هذه التغييرات هو نقل تنفيذ المساعدات إلى مزودي الخدمات والمتاجر المتخصصة، لتقوم الجمعية بدورها الرقابي والتنسيقي فقط.</p>
  <p><strong>-- من هم مزودو الخدمات؟</strong></p>
  <p>هم المتاجر، الشركات، والمراكز المتخصصة التي تقدم سلعًا أو خدمات تتوافق مع نوع المساعدات التي تديرها الجمعية. ويشمل ذلك على سبيل المثال لا الحصر:</p>
  <ul>
  <li>المتاجر الغذائية (للسلال والمساعدات التموينية)</li>
  <li>محلات الملابس (للكساء وكسوة العيد)</li>
  <li>الصيدليات والمراكز الطبية (للمساعدات الصحية)</li>
  <li>المراكز التعليمية والتدريبية</li>
  <li>محلات الأدوات المنزلية والأجهزة</li>
  <li>شركات التوصيل</li>
  <li>المطاعم</li>
  <li>مراكز الترفيه</li>
  <li>مكاتب الاستشارات القانونية أو الأسرية... وغيرها</li>
  </ul>
  <p><strong>-- ما هو دورهم في دورة حياة صرف المساعدة؟</strong></p>
  <p>مزودو الخدمات في منصة منافذ لا يُعتبرون منفذين فقط، بل هم حلقة التشغيل الأساسية، ومن دونهم لا تكتمل دورة الصرف. وتشمل أدوارهم:</p>
  <ul>
  <li><strong>توفير الخدمة أو المنتج</strong>: يقدم مزود الخدمة السلع أو الخدمات المطلوبة للمستفيد بحسب نوع المساعدة (غذائية، صحية، كساء، استشارية، تعليمية...).</li>
  <li><strong>استقبال المستفيدين</strong>: يتعامل مع المستفيدين مباشرة بوسائل الدفع المعتمدة في منافذ (بطاقة، قسيمة، تطبيق...). يضمن تنفيذ الصرف بشكل إنساني واحترافي يشبه تجربة العميل العادي.</li>
  </ul>
  <p><strong>-- ما هي القيمة المضافة لمزودي الخدمات؟</strong></p>
  <p><strong>على جودة تنفيذ المشروع:</strong></p>
  <ul>
  <li>تنفيذ احترافي عبر متخصصين.</li>
  <li>تقليل نسب الخطأ.</li>
  <li>سرعة الإنجاز وسلاسة العمليات.</li>
  </ul>
  <p><strong>على المستفيد:</strong></p>
  <ul>
  <li>تجربة كريمة تشبه تجربة التسوّق المعتادة.</li>
  <li>تنوع الخيارات وتوفر الخدمات في منطقته.</li>
  </ul>
  <p><strong>على الجمعية:</strong></p>
  <ul>
  <li>التفرغ للأدوار الاستراتيجية والتنموية.</li>
  <li>إدارة مشاريع متعددة دون إرهاق إداري أو ميداني.</li>
  <li>تقليل المخاطر المتعلقة في إدارة السلع و حفظها و عنايتها.</li>
  </ul>
  <p><strong>الخلاصة:</strong></p>
  <p>مزودو الخدمات هم الشريك التنفيذي للجمعيات داخل منصة منافذ. وجودهم ليس فقط ضرورة تشغيلية، بل هو تحوّل في منهج العمل الخيري، من التوزيع اليدوي إلى منظومة احترافية تتكامل فيها الجمعيات مع السوق لخدمة المستفيد بكرامة، وفعالية، وشفافية.</p>`,
    description_En: `<p>Previously, charitable associations used to handle the process of disbursing aid themselves: storage, distribution, coordination, follow-up... But this traditional approach consumed the association's energy, doubled costs, and reduced efficiency.</p>
  <p>Hence, the idea of the Manafith platform came to redefine the roles of actors in charitable work. One of the most important changes is transferring the implementation of aid to service providers and specialized stores, allowing the association to focus only on supervisory and coordination roles.</p>
  <p><strong>-- Who are the service providers?</strong></p>
  <p>They are stores, companies, and specialized centers that offer goods or services that align with the type of aid managed by the association. This includes, but is not limited to:</p>
  <ul>
  <li>Grocery stores (for food baskets and supplies)</li>
  <li>Clothing stores (for clothing and holiday attire)</li>
  <li>Pharmacies and medical centers (for health aid)</li>
  <li>Educational and training centers</li>
  <li>Household goods and appliance stores</li>
  <li>Delivery companies</li>
  <li>Restaurants</li>
  <li>Entertainment centers</li>
  <li>Legal or family consulting offices... and others</li>
  </ul>
  <p><strong>-- What is their role in the aid disbursement lifecycle?</strong></p>
  <p>Service providers on the Manafith platform are not just implementers; they are the core operational link, and without them, the disbursement cycle cannot be completed. Their roles include:</p>
  <ul>
  <li><strong>Providing the service or product</strong>: The service provider offers the required goods or services to the beneficiary according to the type of aid (food, health, clothing, consulting, educational, etc.).</li>
  <li><strong>Receiving beneficiaries</strong>: They interact directly with beneficiaries using the payment methods approved by Manafith (card, voucher, app, etc.). They ensure that disbursement is carried out in a humane and professional manner, similar to a regular customer experience.</li>
  </ul>
  <p><strong>-- What is the added value of service providers?</strong></p>
  <p><strong>On project execution quality:</strong></p>
  <ul>
  <li>Professional execution through specialists.</li>
  <li>Reduced error rates.</li>
  <li>Faster completion and smoother operations.</li>
  </ul>
  <p><strong>On the beneficiary:</strong></p>
  <ul>
  <li>A dignified experience similar to regular shopping.</li>
  <li>Diverse options and availability of services in their area.</li>
  </ul>
  <p><strong>On the association:</strong></p>
  <ul>
  <li>Focus on strategic and developmental roles.</li>
  <li>Manage multiple projects without administrative or field fatigue.</li>
  <li>Reduce risks related to managing, storing, and maintaining goods.</li>
  </ul>
  <p><strong>Conclusion:</strong></p>
  <p>Service providers are the executive partners of associations within the Manafith platform. Their presence is not just an operational necessity but a transformation in the methodology of charitable work—from manual distribution to a professional system where associations integrate with the market to serve beneficiaries with dignity, efficiency, and transparency.</p>`,
  image: c_blog_image2,
  background: c_blog_Bg2,
  },
]


export const productsData=[
  {
    id: 1,
    title_Ar: "منافذ توصيل",
    title_En: "Manafith Delivery",
    description_Ar: `<p>القصة ما بين ( نقطتين و مندوب توصيل )</p>
<p>بدون أجور تأسيس خدمة و لا أجور إستضافة.</p>
<p>نظام مصمم خصيصا في إدارة التوصيل الشحنات و الطرود . ببيئة مغلقة خاصة بالمنشأة و عملائها أو منسوبيها . مما يضيف على العمل طابعة الجودة و التخصص.</p>
<p>مع إمكانية التعاقد مع مناديب التوصيل بشكل مباشر دون الرجوع لشركة منافذ السعودية . سواء فتح باب التوظيف أو التطوع عبر اشتراطات و حوافز تحددها المنشأة بنفسها.</p>
<p>موارد لا محدودة كـ نقاط التقاط و مشاريع و مناديب توصيل و عملاء أو مستفيدين</p>
<p><strong>منافذ توصيل - الكتيب التعريفي</strong></p>

<p><strong>نبذة عامة حول المنتج:</strong></p>
<p>الفكرة هي: (( نقطتين و مندوب توصيل ))</p>
<ul style="list-style-type: disc; padding-right: 20px;">
<li><strong>نقطة التقاط</strong>: وهي موقع تواجد السلعة تحدد عبر الخريطة . كـ ( مستودع الجمعية – او المتجر – أو الصيدلية )</li>
<li><strong>نقطة تسليم</strong>: وهو مكان تواجد المستفيد أو العميل كـ عنوان المنزل مثلا .( يحدد عبر العميل نفسة أو عبر سجل العملاء )</li>
<li><strong>مندوب التوصيل</strong>: وهو إما موظف او متطوع او متعاون مع الجهة يقوم بالتقاط السلعة من نقطة الالتقاط و توصيلها إلى نقطة التسليم</li>
<li><strong>رمز التسليم</strong>: وهو رمز مكون من 4 ارقام يتم إرساله للمستفيد أو العميل و بدورة يسلمه للمندوب في حالة استلامة للسلعة و بهذا نكون وثقت عملية التسليم بطريقة سهلة و دقيقيه</li>
</ul>

<p><strong>بيئة العمل و الية التشغيل:</strong></p>
<p>مع التطور الهائل في البنية التحتية التي وفرتها الجهات المختصة في المملكة العربية السعودي . أصبحت الفرص متاحة لتطوير الخدمات و الاليات و طرق التعامل مع الاحتياجات و التطلعات بأحدث التقنيات.</p>
<p>و بهذا كل ما تحتاجه الجهة لتوصيل سلعة او خدمة لمستفيد عبر نظام منافذ ديليفري هي وضع النقاط ( نقطة الالتقاط و نقطة التسليم ) على الخريطة وترك الدفة للمشرفين بتوزيع المهام على مناديب التوصيل بشكل مباشر عبر طريقة بصرية مبسطة . مما يتح لهم رسم تصور لحظي عن تقدم العمل بمجر النظر في الخريطة داخل النظام و التي تظهر الطلبات و حالتها عبر ايقونات مخصصة بالوان المراحل . تحمل في طياتها بيانات الشحنة و أطرافها و حالة التقدم.</p>
<p>أو ترك الحرية لمناديب التوصيل بكافة انواعهم سواء ( موظفين أو متطوعين .. ) في اختيار الطلبات التي تناسب خط سيرهم و اوقاتهم . و منحهم شعور الحرية في تنفيذ و توصيل الشحنات بما يتناسب مع أوقاتهم و ضروفهم . أي انهم هم من يضعون المسارات و المهام لأنفسهم بطريقة سهلة و ممتعة.</p>

<p><strong>كيفية تحديد عناوين العملاء و المستفيدين:</strong></p>
<p>تتم عملية تحديد العنوان بطريقة سهلة و بخطوات يسيرة . يتم إرسال رسالة نصية لجوال العميل أو مستفيد يحمل رابط مجرد فتح العميل لهذا الرابط يتم تحديد موقعه فورا و يقوم النظام بالتأكيد مع العميل على صحة الموقع مع إمكانية تحديد الوقت المناسب للتسليم و كذلك ادخال وصف إضافي للعنوان من قبل العميل.</p>

<p><strong>بعض الأفكار لنظام منافذ ديليفري في العمل الخيري أو التطوعي:</strong></p>
<ul style="list-style-type: disc; padding-right: 20px;">
<li><strong>الاكتفاء الذاتي</strong>: تستطيع الجهة ان تدير عملية توصيل الطلبات ( من سلع أو خدمات أو مساعدات ) من مستودعاتها أو المتاجر للمستفيدين . عبر مناديب توصيل بمعرفتها و حسب اشتراطاتها و حوافزها . دون الحاجة إدخال جهات خارجية او اعتماد تطبيقات تجارية</li>
<li><strong>دعم اللوجستي للمستفيدين</strong>: بحيث تستطيع الجهة عبر منافذ ديليفري دعم المستفيدين في تسويق منتجاتهم ( كـ الاسر المنتجة ) بحيث تتكفل الجهة بتوصيل المنتج من الاسرة المنتجة إلى المشتري مجانا أو برسوم رمزية . محققه بذلك الدعم الازم و التي تحتاجة الاسرة المنتجة لمواصلة عملها و تجارتها</li>
<li><strong>توفير فرص وظيفية</strong>: بما أن الجهة هي من تقوم بجلب المناديب و التعاقد معهم عبر اشتراطاتها و حوافزها .. تستطيع ان تحصر هذه الفرص لأسر المستفيدة من الجهة و التي تنطبق عليها الشروط , و بهذا حولت المستفيد إلى نشط و مكتفي بشكل كامل او جزئي عبر توفير له فرص عمل لا يستطع الحصول عليها وحدة . محققه بذلك اعلى مستويات الدعم للاسر</li>
<li><strong>الاستثمار</strong>: بحيث تستطيع الجهة التعاقد مع جهات سواء حكومية أو من القطاع الخاص او جهات خيرية أخرى بنفس المنطقة و القيام بعملية توصيل سلعها أو خدماتها مساعداتها , و بدورها (الجهة) توفر المناديب بما يحقق الأهداف لجميع الأطراف . و تدير هذا الاستثمار بطرق ذكية و معتمدة على نظام يجعلها بمصافي شركات التوصيل المتوفرة بالسوق و تمتلك الأسباب التقنية لنجاح هذه الشركات</li>
</ul>`,
    description_En: `<p>The story between (two points and a delivery representative)</p>
<p>No service setup fees or hosting fees.</p>
<p>A system specifically designed for managing the delivery of shipments and parcels. In a closed environment specific to the establishment and its customers or employees. This adds a stamp of quality and specialization to the work.</p>
<p>With the possibility of contracting directly with delivery representatives without referring to Manafith Saudi Arabia company. Whether opening the door for employment or volunteering through conditions and incentives determined by the establishment itself.</p>
<p>Unlimited resources such as pickup points, projects, delivery representatives, and customers or beneficiaries.</p>
<p><strong>Manafith Delivery - Introductory Brochure</strong></p>

<p><strong>General Overview of the Product:</strong></p>
<p>The idea is: ((two points and a delivery representative))</p>
<ul style="list-style-type: disc; padding-left: 20px;">
<li><strong>Pickup Point</strong>: The location of the goods determined via the map. Such as (association warehouse - store - or pharmacy)</li>
<li><strong>Delivery Point</strong>: The location of the beneficiary or customer such as home address. (Determined by the customer themselves or through customer records)</li>
<li><strong>Delivery Representative</strong>: Either an employee, volunteer, or collaborator with the entity who picks up the goods from the pickup point and delivers them to the delivery point</li>
<li><strong>Delivery Code</strong>: A 4-digit code sent to the beneficiary or customer, who then gives it to the representative upon receiving the goods, thus documenting the delivery process in an easy and accurate way</li>
</ul>

<p><strong>Work Environment and Operating Mechanism:</strong></p>
<p>With the tremendous development in infrastructure provided by the relevant authorities in Saudi Arabia, opportunities have become available to develop services, mechanisms, and ways of dealing with needs and aspirations using the latest technologies.</p>
<p>Thus, all the entity needs to deliver a product or service to a beneficiary through the Manafith Delivery system is to place the points (pickup point and delivery point) on the map and leave the steering to supervisors to distribute tasks to delivery representatives directly through a simplified visual method. This allows them to draw an instant visualization of work progress just by looking at the map within the system, which shows requests and their status through specialized icons with stage colors, carrying within them shipment data, parties, and progress status.</p>
<p>Or giving freedom to delivery representatives of all types (employees or volunteers...) to choose requests that suit their routes and times, giving them a sense of freedom in executing and delivering shipments according to their times and circumstances. Meaning they set the routes and tasks for themselves in an easy and enjoyable way.</p>

<p><strong>How to Determine Customer and Beneficiary Addresses:</strong></p>
<p>The address determination process is done in an easy way with simple steps. A text message is sent to the customer's or beneficiary's mobile containing a link; when the customer opens this link, their location is immediately determined, and the system confirms with the customer the accuracy of the location with the possibility of determining the appropriate delivery time as well as entering an additional description of the address by the customer.</p>

<p><strong>Some Ideas for Manafith Delivery System in Charitable or Volunteer Work:</strong></p>
<ul style="list-style-type: disc; padding-left: 20px;">
<li><strong>Self-sufficiency</strong>: The entity can manage the process of delivering orders (goods, services, or aid) from its warehouses or stores to beneficiaries through delivery representatives known to it and according to its conditions and incentives, without the need to involve external parties or rely on commercial applications</li>
<li><strong>Logistical Support for Beneficiaries</strong>: Where the entity can through Manafith Delivery support beneficiaries in marketing their products (such as productive families) so that the entity undertakes the delivery of the product from the productive family to the buyer free of charge or for a nominal fee, thus achieving the necessary support that the productive family needs to continue its work and trade</li>
<li><strong>Providing Job Opportunities</strong>: Since the entity is the one that brings the representatives and contracts with them through its conditions and incentives, it can limit these opportunities to families benefiting from the entity that meet the conditions, thus transforming the beneficiary into an active and self-sufficient person either completely or partially by providing them with job opportunities they cannot obtain alone, thereby achieving the highest levels of support for families</li>
<li><strong>Investment</strong>: Where the entity can contract with entities whether governmental, private sector, or other charitable entities in the same area and carry out the process of delivering their goods, services, or aid, and in turn (the entity) provides the representatives in a way that achieves the goals for all parties, and manages this investment in smart ways based on a system that puts it on par with delivery companies available in the market and possesses the technical reasons for the success of these companies</li>
</ul>`,
    image:p_image1,
  },
  {
    id: 2,
    title_Ar: "نظام مواسم",
    title_En: "Mawasim System",
    description_Ar: `<p>هل فكرت بتوفير بطاقات مسبقة الدفع أو محافظ إلكترونية للعملاء؟</p>
  <p>هل سئلت من قبل العملاء عن خدمة تقديم الهدايا أو المساعدات أو العضويات في المتجر؟</p>
  <p>الآن نظام مواسم يعتبر من الأنظمة المتطورة في مجال إدارة المال المقيد، فهو يسمح بإنشاء وإدارة بطاقات مسبقة الدفع والقسائم الإلكترونية ومحافظ العملاء بمنصة واحدة.</p>
  <p>ويعمل النظام مع المتاجر بشتى أنواعها سواء التقليدية أو متاجر إلكترونية، ذات فرع واحد أو متعددة الفروع.</p>
  <p>وبهذا يمكنك تقديم الخدمة للعملاء كل واحد حسب موسمه (هدايا أو مساعدات أو مكافآت... الخ)</p>
  <p>ويعتبر النظام الوحيد الذي يتيح للعميل تسوية الصفقات وإعادة استخدام بواقي الأرصدة مرة أخرى.</p>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>احتساب الأجور مبني على قيمة التعامل الفعلي</li>
  <li>سهولة في التشغيل ومرونة في الأداء</li>
  <li>شفافية مع العملاء وخدمات متنوعة وعصرية</li>
  </ul>
  
  <p><strong>نبذة عامة حول المنتج:</strong></p>
  <p>يتيح نظام مواسم للمتاجر بإصدار الخدمات التالية:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>بطاقات مسبقة الدفع كـ بطاقات هدايا وبطاقات شكر أو بطاقات تسوق في المتجر</li>
  <li>قسائم إلكترونية (عبر رسائل نصية أو تطبيق أجهزة ذكية) كـ هدايا أو قسائم تسوق في المتجر</li>
  <li>فتح محافظ للعملاء لضبط مصروف مشترياتهم الخاصة أو المنزل عبر السائقين أو الأبناء</li>
  </ul>
  <p>كما يمكن للمتجر طلب تصاميم للبطاقات تحاكي هويته وشعاره وكذلك الموسم المستهدف.</p>
  
  <p><strong>المميزات للمتجر:</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>فتح وإدارة حسابات العملاء</li>
  <li>إنشاء صفقات ما بين المتجر والعميل بشكل سهل ومرن</li>
  <li>إمكانية التحكم بالبطاقات سواء بتمديد صلاحيتها أو قفلها</li>
  <li>إدارة مخزون البطاقات وتتبع حركتها في الفروع</li>
  <li>إنشاء بطاقات أو قسائم تعمل في فروع دون فروع أخرى لنفس المتجر</li>
  <li>عمل تسويات لصفقات العملاء بشكل سريع وبخطوات سهلة</li>
  <li>تتبع حركة مشتريات البطاقات على مستوى العملاء والفروع</li>
  </ul>
  
  <p><strong>المميزات للعميل:</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>إمكانية الاطلاع على كشف حساب المحفظة بشكل مباشر</li>
  <li>إمكانية التحكم ببطاقاته سواء بالتنشيط أو القفل</li>
  <li>إمكانية ربط البطاقات ببعض البيانات كاسم المستخدم أو لمن أهداها</li>
  <li>إمكانية تسوية صفقة البطاقات وإرجاع رصيد البواقي للمحفظة</li>
  <li>إمكانية إصدار قسائم إلكترونية شرائية بدون الرجوع للمتجر</li>
  <li>إمكانية التحكم بقيمة القسيمة وتاريخ صلاحيتها وتسويتها بشكل مباشر</li>
  <li>إمكانية قفل القسيمة وإرجاع قيمتها للمحفظة بشكل مباشر</li>
  <li>كل بطاقة أو قسيمة لها رقم سري وحساب على التطبيق يستطيع المستفيد الدخول لمعرفة رصيدها ومواقع المتجر للاستفادة منها</li>
  </ul>
  
  <p><strong>المميزات للمستخدم النهائي (حامل البطاقة):</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>معرفة رصيد بطاقته بسهولة عبر الموقع أو التطبيق</li>
  <li>معرفة مواقع وعناوين فروع المتجر عبر الموقع أو التطبيق</li>
  <li>تغيير الرقم السري للبطاقة أو القسيمة</li>
  <li>ربطها برقم جوال والحصول على رسائل نصية عن حركة البطاقة عند الشراء</li>
  <li>إصدار كشف حساب البطاقة بشكل كامل</li>
  </ul>`,
    description_En: `<p>Have you thought about providing prepaid cards or electronic wallets for customers?</p>
  <p>Have you ever been asked by customers about gift services, assistance, or store memberships?</p>
  <p>Now, the Mawasim system is considered one of the advanced systems in the field of managing restricted funds, as it allows creating and managing prepaid cards, electronic vouchers, and customer wallets on a single platform.</p>
  <p>The system works with all types of stores, whether traditional or electronic, with single or multiple branches.</p>
  <p>Thus, you can provide the service to customers, each according to their season (gifts, assistance, rewards, etc.)</p>
  <p>It is considered the only system that allows the customer to settle deals and reuse remaining balances again.</p>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Fee calculation based on actual transaction value</li>
  <li>Ease of operation and flexibility in performance</li>
  <li>Transparency with customers and diverse, modern services</li>
  </ul>
  
  <p><strong>General Overview of the Product:</strong></p>
  <p>The Mawasim system allows stores to issue the following services:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Prepaid cards such as gift cards, thank you cards, or shopping cards in the store</li>
  <li>Electronic vouchers (via text messages or smart device applications) such as gifts or shopping vouchers in the store</li>
  <li>Opening wallets for customers to control their personal or household shopping expenses through drivers or children</li>
  </ul>
  <p>The store can also request card designs that mimic its identity, logo, and the target season.</p>
  
  <p><strong>Features for the Store:</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Opening and managing customer accounts</li>
  <li>Creating deals between the store and the customer in an easy and flexible manner</li>
  <li>Ability to control cards by extending their validity or locking them</li>
  <li>Managing card inventory and tracking their movement in branches</li>
  <li>Creating cards or vouchers that work in some branches but not others for the same store</li>
  <li>Settling customer deals quickly and with easy steps</li>
  <li>Tracking card purchase movements at the customer and branch levels</li>
  </ul>
  
  <p><strong>Features for the Customer:</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Ability to view wallet account statements directly</li>
  <li>Ability to control their cards through activation or locking</li>
  <li>Ability to link cards to data such as username or who gifted it</li>
  <li>Ability to settle card deals and return remaining balances to the wallet</li>
  <li>Ability to issue electronic purchase vouchers without referring to the store</li>
  <li>Ability to control the voucher value, expiration date, and settle directly</li>
  <li>Ability to lock the voucher and return its value to the wallet directly</li>
  <li>Each card or voucher has a secret number and an account on the application that the beneficiary can access to know its balance and store locations to benefit from it</li>
  </ul>
  
  <p><strong>Features for the End User (Card Holder):</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Easily know their card balance through the website or application</li>
  <li>Know the locations and addresses of store branches through the website or application</li>
  <li>Change the card or voucher password</li>
  <li>Link it to a mobile number and receive text messages about card activity when purchasing</li>
  <li>Issue a complete card account statement</li>
  </ul>`,
    image: p_image2,
  },
  {
    id: 3,
    title_Ar: "منافذ شراكات",
    title_En: "Manafith Partnerships",
    description_Ar: `<p>هل فكرت بمنح موظفينك إمتيازات وحوافز غير مالية؟</p>
  <p>هل ترغب أن يفتخر موظفيك بإنتمائهم لمنشأتك؟</p>
  <p>هل قدمت لك جهات خارجية خصومات وإمتيازات لموظفيك وترغب بإدارتها واستثمارها بشكل منظم وتصرف لهم كحوافز ومكافآت؟</p>
  <p>هل لديك عروض وإمتيازات وترغب بمنحها لمنشأة تجارية أو جهة حكومية؟ لكسب منسوبيهم كعملاء لديك؟</p>
  <p>هل فكرت بعمل شراكة مع احدى القطاعات عبر تبادل إمتيازات ومنافع؟</p>
  <p>كل هذه الأفكار يمكن صياغتها وتنفيذها عبر نظام واحد فقط..</p>
  <p>سواء كنت جهة مستفيدة من إمتيازات أو جهة مانحة للإمتيازات، كل ما تحتاجه هو نظام منافذ شراكات.</p>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>نظام واحد يجمع كل من: (الجهات المانحة والمستفيدة) باختلاف قطاعاتهم وأنشطتهم وأنظمتهم ببوابة واحدة</li>
  <li>مرونة في تشكيل الامتيازات وسهولة في تداولها وتتبع حركتها</li>
  <li>متعدد الوسائط والتقنيات (بطاقات - قسائم إلكترونية - تطبيق للأجهزة الذكية)</li>
  </ul>
  
  <p><strong>نبذة عامة حول المنتج:</strong></p>
  
  <p><strong>ما هو نظام منافذ شراكات:</strong></p>
  <p>هو نظام لديه ثلاثة أطراف رئيسية:</p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>الجهة المانحة للأمتيازات</strong></li>
  <li><strong>الجهة المستفيدة من الامتيازات</strong></li>
  <li><strong>المستفيد النهائي (حامل بطاقة الامتياز)</strong></li>
  </ul>
  
  <p><strong>الجهة المانحة للإمتيازات:</strong></p>
  <p>وهي الجهة التي تمنح الخصومات أو الهدايا لحامل البطاقة. وتقوم بمنح الامتيازات والهدايا لأهدافها الخاصة، سواء لجلب عملاء جدد أو الدعوة لزيارة فرع جديد أو إستهداف فئة محددة من الموظفين عبر خصوماتها أو إمتيازاتها.</p>
  
  <p><strong>الجهة المستفيدة:</strong></p>
  <p>وهي الجهة (سواء قطاع حكومي أو تجاري أو خيري) التي تتلقى العروض والخصومات والامتيازات من الجهات المانحة وهي بدورها تقوم بتوزيع هذه الامتيازات على موظفيها حسب الاتفاق مع المانح.</p>
  
  <p><strong>المستفيد النهائي:</strong></p>
  <p>هو الشخص حامل بطاقة الامتياز والتي حصل عليها من الجهة التي يعمل لديها، كمكافأة أو تحفيز أو عضوية انتساب. يتمتع بإمتيازاتها لدى الجهات المانحة والتي اتفقت معها الجهة التي يعمل لديها.</p>
  
  <p><strong>لماذا سمي نظام منافذ شراكات؟</strong></p>
  <p>لأنه من خلال هذا النظام يمكن لجميع الأطراف عمل شراكة لتبادل منافع ومصالح بشكل ممنهج ومنظم ومرن ويمكن قياس أثره بسهولة ويسر.</p>`,
    description_En: `<p>Have you thought about giving your employees non-financial privileges and incentives?</p>
  <p>Do you want your employees to be proud of their belonging to your establishment?</p>
  <p>Have external parties offered discounts and privileges for your employees and you want to manage and invest them in an organized manner and disburse them as incentives and rewards?</p>
  <p>Do you have offers and privileges that you want to give to a commercial establishment or government entity? To gain their affiliates as customers for you?</p>
  <p>Have you thought about establishing a partnership with one of the sectors through exchanging privileges and benefits?</p>
  <p>All these ideas can be formulated and implemented through one system only..</p>
  <p>Whether you are a beneficiary of privileges or a provider of privileges, all you need is the Manafith Partnerships system.</p>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>One system that gathers both: (providing and beneficiary entities) with their different sectors, activities, and systems through one portal</li>
  <li>Flexibility in forming privileges and ease in trading and tracking their movement</li>
  <li>Multi-media and technologies (cards - electronic vouchers - smart device application)</li>
  </ul>
  
  <p><strong>General Overview of the Product:</strong></p>
  
  <p><strong>What is the Manafith Partnerships system:</strong></p>
  <p>It is a system with three main parties:</p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Privilege Providing Entity</strong></li>
  <li><strong>Privilege Beneficiary Entity</strong></li>
  <li><strong>End Beneficiary (Privilege Card Holder)</strong></li>
  </ul>
  
  <p><strong>Privilege Providing Entity:</strong></p>
  <p>This is the entity that grants discounts or gifts to the card holder. It provides privileges and gifts for its own objectives, whether to attract new customers, invite to visit a new branch, or target a specific category of employees through its discounts or privileges.</p>
  
  <p><strong>Beneficiary Entity:</strong></p>
  <p>This is the entity (whether government, commercial, or charitable sector) that receives offers, discounts, and privileges from providing entities and in turn distributes these privileges to its employees according to the agreement with the provider.</p>
  
  <p><strong>End Beneficiary:</strong></p>
  <p>This is the person holding the privilege card that they obtained from the entity they work for, as a reward, incentive, or membership. They enjoy its privileges with the providing entities that have agreements with the entity they work for.</p>
  
  <p><strong>Why is it called the Manafith Partnerships system?</strong></p>
  <p>Because through this system, all parties can establish partnerships to exchange benefits and interests in a systematic, organized, and flexible manner, and its impact can be measured easily and conveniently.</p>`,
    image: p_image3,
  },
  {
    id: 4,
    title_Ar: "منافذ مخصصات",
    title_En: "Manafith Allowances",
    description_Ar: `<p><strong>الرؤية:</strong></p>
  <p>إنشاء شراكة تجارية بين القطاعات بمختلف انتماءاتها مع السوق التجاري مبني على الخدمات المقدمة والمنفعة المتبادلة.</p>
  
  <p><strong>الرسالة:</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>استخدام المخصصات العينية والخدمات بطريقة المال المقيد بشكل آمن وسريع وبشكل منظم باستخدام أنظمة رقمية وقابل للقياس والتعقب</li>
  <li>ضبط الجودة في تقديم الخدمة لمنسوبي المنظمات بشكل أسهل وأسرع عبر عدة خيارات مع تتبع الأثر والقياس</li>
  <li>الانتقال من مرحلة تقديم المخصصات والخدمات بشكل يدوي أو أموال نقدية إلى خيارات متنوعة تلبي احتياج المنسوبين من خلال نظام الكتروني</li>
  <li>رفع مستوى التنسيق والشفافية مع الشركاء التجاريين والمنظمات ليولد شراكة فعالة تخدم مصلحة جميع الأطراف</li>
  </ul>
  
  <p><strong>نبذة عامة حول المنتج:</strong></p>
  <p>نظام منافذ مخصصات صمم لإدارة صرف المخصصات والخدمات عبر المال المقيد، وتتمثل مهام عمل النظام في إدارة صرف وتقديم المخصصات العينية والخدمات بشكل ممنهج يرتكز على:</p>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>ترشيد الجهود والتكاليف المادية والبشرية للجهات الحكومية والتجارية</li>
  <li>تقليص عمليات المناقصات والمشتريات وتحديدها في قطاع تجاري محدد</li>
  <li>إتاحة المنافسة العادلة حسب الخدمات المقدمة من مزودي الخدمات والمنتجات</li>
  <li>تمكين المستفيد النهائي من الخدمة بالحصول على المخصص عبر عدة خيارات تحددها المنظمة</li>
  <li>تحديد الاشتراطات الفنية والإدارية والمالية بالتنسيق مع الجهات التجارية المعتمدة</li>
  </ul>`,
    description_En: `<p><strong>Vision:</strong></p>
  <p>Establishing commercial partnerships between sectors of various affiliations with the commercial market based on services provided and mutual benefit.</p>
  
  <p><strong>Mission:</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Using in-kind allowances and services through restricted funds in a safe, fast, and organized manner using digital systems that are measurable and traceable</li>
  <li>Quality control in providing service to organization affiliates easier and faster through multiple options with impact tracking and measurement</li>
  <li>Transitioning from manually providing allowances and services or cash to diverse options that meet the needs of affiliates through an electronic system</li>
  <li>Enhancing the level of coordination and transparency with commercial partners and organizations to create effective partnerships that serve the interests of all parties</li>
  </ul>
  
  <p><strong>General Overview of the Product:</strong></p>
  <p>The Manafith Allowances system is designed to manage the disbursement of allowances and services through restricted funds. The system's tasks include managing the disbursement and provision of in-kind allowances and services in a systematic manner focused on:</p>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Rationalizing efforts and material/human costs for government and commercial entities</li>
  <li>Reducing tender and procurement processes and specifying them in a particular commercial sector</li>
  <li>Enabling fair competition based on services provided by service and product providers</li>
  <li>Empowering the end beneficiary of the service to obtain the allowance through multiple options determined by the organization</li>
  <li>Determining technical, administrative, and financial requirements in coordination with approved commercial entities</li>
  </ul>`,
    image: p_image4,
  },
  {
    id: 5,
    title_Ar: "منافذ قسائم",
    title_En: "Manafith Vouchers",
    description_Ar: `<p>منافذ قسائم نظام إحترافي ومتطور في الأداء سهل الاستخدام ومتعدد الأغراض</p>
  <p>ببساطة يمكنك إنشاء قسائم إلكترونية وشحنها برصيد شرائي أو سلع محددة وإرسالها للمستفيد كـ هدية أو مساعدة عبر رسالة نصية على الجوال</p>
  <p>بحيث يمكن للمستفيد الاستفادة منها عبر متجر أو عدة متاجر، يتم تحديدها والاتفاق معهم مسبقا</p>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>يقدم الخدمة المثالية</li>
  <li>يخدم المشاريع الموسمية</li>
  <li>إمكانية التتبع والتحقق من تنفيذ المشاريع</li>
  </ul>
  
  <p><strong>نبذة عامة حول المنتج:</strong></p>
  <p>نظام منافذ قسائم</p>
  <p>يمكن من خلاله إنشاء قسائم إلكترونية وشحن رصيدها بـ:</p>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>رصيد مالي شرائي</strong></li>
  <li><strong>رصيد عيني</strong> كتحديد سلعة أو خدمة أو مجموعة سلع أو خدمات كعدد</li>
  </ul>
  
  <p>ثم يتم إرسالها إلى الشخص المستهدف عبر رسالة نصية عبر الجوال أو طباعتها على ورق أو بطاقة بلاستيكية</p>
  
  <p><strong>وتحتوي القسيمة على المميزات التالية:</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>رقم سري قابل للتعديل من قبل المستفيد</li>
  <li>تاريخ صلاحية</li>
  <li>إمكانية الارتباط بمتجر واحد أو عدة متاجر بنفس الوقت</li>
  <li>تطبيق وموقع إلكتروني للإطلاع على تفاصيل رصيد وخدمات القسيمة مع مواقع المتاجر المعتمدة لديهم</li>
  </ul>
  
  <p><strong>الاستخدامات الشائعة للنظام:</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>الجمعيات الخيرية</li>
  <li>المؤسسات المانحة</li>
  <li>المدارس والمعاهد والجامعات</li>
  <li>الأندية الرياضية</li>
  <li>شركات تنظيم المؤتمرات والفعاليات</li>
  </ul>`,
    description_En: `<p>Manafith Vouchers is a professional and advanced performance system that is easy to use and multi-purpose</p>
  <p>Simply, you can create electronic vouchers, load them with purchase balance or specific goods, and send them to the beneficiary as a gift or assistance via text message on mobile</p>
  <p>Where the beneficiary can benefit from them through one store or several stores, which are determined and agreed upon in advance</p>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Provides ideal service</li>
  <li>Serves seasonal projects</li>
  <li>Ability to track and verify project implementation</li>
  </ul>
  
  <p><strong>General Overview of the Product:</strong></p>
  <p>Manafith Vouchers system</p>
  <p>Through it, electronic vouchers can be created and their balance loaded with:</p>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Purchase financial balance</strong></li>
  <li><strong>In-kind balance</strong> such as specifying a commodity, service, basket of goods, or services as a quantity</li>
  </ul>
  
  <p>Then they are sent to the target person via text message on mobile or printed on paper or plastic card</p>
  
  <p><strong>The voucher contains the following features:</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Secret number that can be modified by the beneficiary</li>
  <li>Expiry date</li>
  <li>Ability to link to one store or multiple stores at the same time</li>
  <li>Application and website to view voucher balance and service details with locations of approved stores</li>
  </ul>
  
  <p><strong>Common Uses of the System:</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Charitable associations</li>
  <li>Donor institutions</li>
  <li>Schools, institutes, and universities</li>
  <li>Sports clubs</li>
  <li>Conference and event organizing companies</li>
  </ul>`,
    image: p_image5,
  },
  {
    id: 6,
    title_Ar: "نظام منافذ",
    title_En: "Manafith System",
    description_Ar: `<p>نظام منافذ، يعد النظام الأول في العالم الذي يدير تسليم المساعدات العينية للمستفيدين من الجمعيات الخيرية بكافة أنواعها وأصنافها عبر آلية موحدة ونظام واحد</p>
  <p>حيث دشن النظام عام 2012م وقد صمم لأهداف كثيرة من أبرزها:</p>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li><strong>حفظ كرامة الأسر أثناء استلامهم المساعدة</strong></li>
  <li><strong>توفير الجهد والمال والوقت على الجمعيات الخيرية</strong></li>
  <li><strong>إشراك القطاع الخاص في أحداث العمل الخيري بما يتناسب مع اختصاصاتهم</strong></li>
  </ul>
  
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>بطاقة واحدة لصرف جميع أنواع المساعدات</li>
  <li>مرونة وسهولة وسرعة في إعداد وصرف المساعدات</li>
  <li>منصة عمل واحدة لعمل شراكات وتعاون ما بين القطاع الخيري والقطاع التجاري</li>
  </ul>
  
  <p><strong>نبذة عامة حول المنتج:</strong></p>
  <p>نظام منافذ، نظام متخصص بإدارة مناولة وتسليم المساعدات العينية للمستفيدين من الجمعيات الخيرية، عبر بطاقات ممغنطة أو قسائم إلكترونية أو تطبيقات للأجهزة الذكية</p>
  
  <p>فالفكرة الأساسية هي عدم حضور المستفيدين لمقر الجمعية أو مستودعاتها وتقليل الاحتكاك معهم، وذلك عبر منحهم حساب عضوية بالنظام وتربط بأحد المعرفات (بطاقة ممغنطة أو قسيمة إلكترونية أو تطبيق على الأجهزة الذكية)</p>
  
  <p>ومن خلال حسابات الأسر في نظام منافذ يتم شحن قيمة المساعدات عبر الجمعية، سواء كقيمة مالية أو كمية عينية (كمثال: غذاء أو كساء أو دواء أو بطانية أو جهاز تكييف... الخ)</p>
  
  <p>ويتم التعاقد مع المتاجر التي تغطي أصناف المساعدات عبر معايير واشتراطات تحددها الجمعية بنفسها</p>
  
  <p>وبهذا يمكن للأسر المستفيدة الذهاب إلى أقرب متجر مناسب واستلام المساعدات العينية أو شراء احتياجاتها عبر البطاقة أو القسيمة الإلكترونية</p>
  
  <p>ثم تقوم الجمعية بتصفية الحساب مع المتاجر عبر كشوف حركة مشتريات الأسر والتي يصدرها النظام بشكل شهري والتي توضح عدد الأسر المستفيدة وقيمة المشتريات لكل متجر على حدا</p>
  
  <p><strong>ومن أبرز مميزات نظام منافذ:</strong></p>
  <ul style="list-style-type: disc; padding-right: 20px;">
  <li>إنشاء عدة بنود مساعدات كـ غذاء وكساء ودواء... الخ وربطها ببطاقة واحدة</li>
  <li>ربط جميع المتاجر المتعاقدة مع الجمعية بنظام واحد وبطاقة واحدة</li>
  <li>إمكانية ربط أكثر من متجر بنفس البند (لترك للأسرة حرية الاختيار أو تغطية منطقة جغرافية واسعة)</li>
  <li>تنوع الأرصدة في النظام (رصيد مالي أو رصيد عيني) حسب أنواع البنود</li>
  <li>خيارات واسعة للارتباط ما بين المتاجر مع النظام (عبر نقاط بيع أو ربط مباشر أو تطبيقات ذكية)</li>
  </ul>`,
    description_En: `<p>Manafith System is considered the first system in the world that manages the delivery of in-kind assistance to beneficiaries from charitable associations of all types and categories through a unified mechanism and a single system</p>
  <p>The system was launched in 2012 and was designed for many objectives, most notably:</p>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li><strong>Preserving the dignity of families while receiving assistance</strong></li>
  <li><strong>Saving effort, money, and time for charitable associations</strong></li>
  <li><strong>Involving the private sector in charitable work according to their specializations</strong></li>
  </ul>
  
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>One card for disbursing all types of assistance</li>
  <li>Flexibility, ease, and speed in preparing and disbursing assistance</li>
  <li>A single work platform for partnerships and cooperation between the charitable sector and the commercial sector</li>
  </ul>
  
  <p><strong>General Overview of the Product:</strong></p>
  <p>Manafith System is a specialized system for managing the handling and delivery of in-kind assistance to beneficiaries from charitable associations, through magnetic cards, electronic vouchers, or smart device applications</p>
  
  <p>The basic idea is to avoid beneficiaries coming to the association's headquarters or warehouses and reduce contact with them, by granting them a membership account in the system linked to one of the identifiers (magnetic card, cardboard voucher, or smart device application)</p>
  
  <p>Through family accounts in the Manafith system, the value of assistance is loaded by the association, whether as a financial value or in-kind quantity (for example: food, clothing, medicine, blankets, air conditioning devices, etc.)</p>
  
  <p>Contracts are made with stores that cover the types of assistance through standards and conditions determined by the association itself</p>
  
  <p>Thus, beneficiary families can go to the nearest appropriate store and receive in-kind assistance or purchase their needs through the card or electronic voucher</p>
  
  <p>The association then settles accounts with stores through statements of family purchase movements issued by the system monthly, which show the number of beneficiary families and the value of purchases for each store separately</p>
  
  <p><strong>Among the most prominent features of the Manafith system:</strong></p>
  <ul style="list-style-type: disc; padding-left: 20px;">
  <li>Creating multiple assistance items such as food, clothing, medicine, etc. and linking them to one card</li>
  <li>Linking all stores contracted with the association to one system and one card</li>
  <li>Possibility to link more than one store to the same item (to give the family freedom of choice or cover a wide geographical area)</li>
  <li>Diversity of balances in the system (financial balance or in-kind balance) according to the types of items</li>
  <li>Wide options for connection between stores and the system (through point of sale, direct connection, or smart applications)</li>
  </ul>`,
    image:p_image6,
  },
]


export const timeLineData2 = 
{
  title_Ar:"منافذ: رحلة رقمنة العمل الخيري",
  title_En:"Manafeh: Digitizing Charity Work",
  subtitle_Ar:"محطات تطوّر المنصة التي غيّرت مفهوم إدارة المساعدات في السعودية",
  subtitle_En:"Key milestones of the platform that transformed aid management in Saudi Arabia",
items:[
  {
    id: 1,
    date: "2009",
    title_Ar: "إطلاق الفكرة",
    title_En: "Idea Launch",
    description_Ar: "انطلاق الفكرة الأولى لمنصة منافذ كحل مبتكر لإدارة المساعدات بشكل منظم وذكي، حيث بدأت الرؤية بتحويل العمل الخيري من النمط التقليدي إلى النظام الرقمي المتكامل.",
    description_En: "The initial idea of Manafeh Platform was launched as an innovative solution for smart and organized aid management, with a vision to transform charitable work from traditional methods to an integrated digital system.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 2,
    date: "2010",
    title_Ar: "اعتماد النظام كمشروع",
    title_En: "Project Approval",
    description_Ar: "تم اعتماد المنصة كمشروع رسمي للتطوير، حيث بدأت مرحلة التخطيط الاستراتيجي ودراسة متطلبات جميع الأطراف المعنية من جمعيات ومستفيدين ومتاجر وجهات إشرافية.",
    description_En: "The platform was officially approved as a development project, starting the strategic planning phase and studying the requirements of all stakeholders including associations, beneficiaries, stores, and regulatory bodies.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 3,
    date: "2014",
    title_Ar: "اعتماد تقنية RF بالبطاقات",
    title_En: "RF Card Technology Adoption",
    description_Ar: "دمج تقنية التردد اللاسلكي (RF) في البطاقات الذكية، مما سمح بإدارة أكثر كفاءة للمساعدات وتجربة مستخدم محسنة للمستفيدين في نقاط الصرف.",
    description_En: "Integration of Radio Frequency (RF) technology in smart cards, enabling more efficient aid management and enhanced user experience for beneficiaries at distribution points.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 4,
    date: "2017",
    title_Ar: "إطلاق الجيل الثالث ويب",
    title_En: "3rd Web Generation Launch",
    description_Ar: "إطلاق النسخة المتطورة من المنصة الإلكترونية التي وفرت واجهة مستخدم محسنة وأدوات متقدمة لإدارة العمليات الخيرية بشكل أكثر سلاسة وشفافية.",
    description_En: "Launch of the advanced web platform version featuring improved user interface and advanced tools for more seamless and transparent management of charitable operations.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 5,
    date: "2018",
    title_Ar: "إطلاق وحدة الدفع أون لاين",
    title_En: "Online Payment Module Launch",
    description_Ar: "تمكين نظام الدفع الإلكتروني للمساهمات والتبرعات، مما سهل عملية التبرع وزاد من الشفافية في تتبع المساهمات المالية.",
    description_En: "Implementation of electronic payment system for contributions and donations, simplifying the donation process and increasing transparency in financial contribution tracking.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 6,
    date: "2019",
    title_Ar: "إطلاق وحدة الزكاة",
    title_En: "Zakat Module Launch",
    description_Ar: "تخصيص وحدة متكاملة لإدارة الزكاة بشكل منظم وآمن، مما وفر حلولاً شاملة لجمع وتوزيع الزكاة وفق الضوابط الشرعية.",
    description_En: "Introduction of a dedicated integrated module for organized and secure Zakat management, providing comprehensive solutions for collection and distribution in accordance with Islamic principles.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 7,
    date: "2020",
    title_Ar: "إطلاق التطبيقات الذكية بيتا",
    title_En: "Smart Applications Beta Launch",
    description_Ar: "إطلاق النسخة التجريبية للتطبيقات الذكية التي مكنت المستفيدين من التسوق بكرامة وحرية، والجمعيات من الإدارة الفعالة عن بعد.",
    description_En: "Beta launch of smart mobile applications enabling beneficiaries to shop with dignity and freedom, while allowing associations to manage operations effectively remotely.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  },
  {
    id: 8,
    date: "2021",
    title_Ar: "إطلاق وحدة التواصل ووحدة المانحين",
    title_En: "Communication & Donors Modules Launch",
    description_Ar: "إطلاق وحدات متخصصة للتواصل الفعال وإدارة علاقات المانحين، مما عزز الشراكة بين القطاع الخيري والقطاع التجاري.",
    description_En: "Launch of specialized modules for effective communication and donor relationship management, enhancing partnerships between the charitable sector and business community.",
    images: [
      c_blog_image1,c_blog_image2,c_blog_image3,c_blog_image4
    ]
  }
]}
export const timeLineData = {
  title_Ar: "رحلة رقمنة العمل الخيري",
  title_En: "Digitizing Charity Work",
  subtitle_Ar: "محطات تطوّر المنصة التي غيّرت مفهوم إدارة المساعدات في السعودية",
  subtitle_En: "Key milestones of the platform that transformed aid management in Saudi Arabia",
  items: [
    {
      id: 1,
      date: "3-2009",
      title_Ar: "القطاع الخيري ",
      title_En: " Charitable sector",
      description_Ar: `بدأت رحلة "منافذ" بفريق صغير داخل الشركة، مكلّف بفهم تحديات العمل الخيري، واستكشاف فرص تحسينه بالتقنية، في وقت كانت فيه المساعدات تُدار بأساليب تقليدية.`,
      description_En: `Manafeeth began its journey with a small internal team tasked with understanding the challenges of charitable work and exploring opportunities to enhance it through technology, at a time when aid was being managed through traditional methods.`,
      images: [c_blog_image8, c_blog_image7, c_blog_image6, c_blog_image5]
    },
    {
      id: 2,
      date: "6-2009",
      title_Ar: `رصد الاحتياج`,
      title_En: "Need Assessment",
      description_Ar: `أجرينا دراسة موسعة لقطاع العمل الخيري، كشفت عن تحديات كبيرة في إدارة الدعم وتوزيع المساعدات، وشكّلت الأساس لفهم الفجوات الحقيقية.`,
      description_En: `We conducted an extensive study of the charitable sector, which revealed significant challenges in managing support and distributing aid, forming the foundation for understanding the real gaps.`,
      images: [c_blog_image3, c_blog_image4]
    },
    {
      id: 3,
      date: "8-2009",
      title_Ar: "التشخيص العميق",
      title_En: `Deep Diagnosis`,
      description_Ar: `بعد مراجعة الاجراء التشغيلي للجمعيات الخيرية، تم تحديد أسباب الهدر، ضعف الشفافية، والبطء في صرف المساعدات و التكاليف التشغيلية العالية ، ما مهّد الطريق لتصميم الحل.`,
      description_En: `After reviewing the operational procedures of charitable organizations, the causes of wastage, lack of transparency, delays in aid disbursement, and high operational costs were identified, paving the way for designing the solution.`,
      images: [c_blog_image7, c_blog_image8, c_blog_image5, c_blog_image6]
    },
    {
      id: 4,
      date: "10-2009",
      title_Ar: "اعتماد الفكرة",
      title_En: "Idea Adoption",
      description_Ar: `تم اعتماد النموذج فكرة النظام، كأداة لإدارة صرف المساعدات والمناولة عبر منصة مركزية، تسهّل على الجمعيات التخطيط والرقابة بدل الانشغال بالتنفيذ.`,
      description_En: `The system's model was adopted as a tool for managing aid disbursement and handling through a centralized platform, enabling associations to focus on planning and oversight rather than being preoccupied with execution.`,
      images: [c_blog_image1, c_blog_image2]
    },
    {
      id: 5,
      date: "12-2009",
      title_Ar: "اعتماد النظام كمشروع",
      title_En: "Adopting the system as a project",
      description_Ar: `بناءً على قوة الفكرة ونضج التصور، تم اعتماد "النظام" كمشروع استراتيجي داخل الشركة، ليكون أول منصة تقنية موجهة لتنظيم صرف ومناولة المساعدات في القطاع الخيري .`,
      description_En: `Based on the strength of the idea and the maturity of the concept, the "system" was adopted as a strategic project within the company, making it the first technological platform aimed at organizing the disbursement and handling of aid in the charitable sector.`,
      images: [c_blog_image3, c_blog_image4, c_blog_image5, c_blog_image6]
    },
    {
      id: 6,
      date: "3-2010",
      title_Ar: "اعتماد تحليل النظام",
      title_En: "System Analysis Approval",
      description_Ar: `تم الانتهاء من التحليل الفني للنظام، بما يشمل تصميم البنية التقنية، ووضع نماذج التشغيل الأساسية التي تضمن الاستقرار والمرونة في الأداء لتشمل العمليات والخدمات المرتبطة بالجمعيات والمستفيدين..`,
      description_En: `The technical analysis of the system has been completed, including the design of the technical architecture and the establishment of core operational models that ensure stability and flexibility in performance, covering processes and services related to associations and beneficiaries.`,
      images: [c_blog_image7, c_blog_image8]
    },
    {
      id: 7,
      date: "8-2011",
      title_Ar: "تم اطلاق النسخة البيتا ",
      title_En: "The beta version was launched.",
      description_Ar: `أُطلقت النسخة التجريبية الأولى من النظام تحت مسمى ( نظام رابط ) ، وتم اختبارها داخليًا عبر محاكاة معقدة مبنية على واقع الجمعيات و الوضع القائم في القطاع التجاري  للتأكد من جاهزيتها الفنية وقابليتها للتطبيق في الميدان.`,
      description_En: `The first pilot version of the system, named "Rabet System," was launched and tested internally through complex simulations based on the reality of associations and the existing situation in the charitable sector to ensure its technical readiness and applicability in the field.`,
      images: [c_blog_image3, c_blog_image4]
    },
    {
      id: 8,
      date: "11-2011",
      title_Ar: "التعاقد مع اول جمعية ",
      title_En: "Contracting with the first association.",
      description_Ar: `شهد هذا التاريخ توقيع أول عقد مع جمعية خيرية لاستخدام النظام ( جمعية أبناء لرعاية الايتام ببريدة ) ، في خطوة تاريخية نحو توطين التقنية داخل بيئة العمل الخيري.`,
      description_En: `On this date, the first contract was signed with a charitable association (Abnaa Association for Orphan Care in Buraidah) to use the system, marking a historic step toward localizing technology within the charitable work environment.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 9,
      date: "11-2012",
      title_Ar: "التدشين الرسمي ",
      title_En: "Official Launch",
      description_Ar: `تم تدشين "نظام رابط " رسميًا بعد اكتمال النسخة التشغيلية، وبدء العمل فعليًا على مشاريع صرف المساعدات عبر النظام في بيئة حقيقية.`,
      description_En: `"Rabet System" was officially launched after the operational version was completed, and work began on aid disbursement projects through the system in a real-world environment.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 10,
      date: "5-2013",
      title_Ar: "اطلاق خدمة زكاة الفطر ",
      title_En: "Launching the Zakat al-Fitr service.",
      description_Ar: `تم تطوير أول خدمة إلكترونية متخصصة لتنظيم صرف زكاة الفطر عبر النظام، لتيسير إيصالها للمستحقين بشكل دقيق وآمن و يعتبر اول نظام يقدم صرف زكاة الفطر عبر بطاقات و المناولة عبر متاجر متخصصة .`,
      description_En: `The first specialized electronic service was developed to organize the disbursement of Zakat al-Fitr through the system, facilitating its accurate and secure delivery to eligible recipients. It is considered the first system to offer Zakat al-Fitr disbursement via cards and handling through specialized stores.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 11,
      date: "8-2013",
      title_Ar: "اطلاق التحديث الاول",
      title_En: "Launching the first update.",
      description_Ar: `أُجري أول تحديث رئيسي على النظام بناءً على ملاحظات المستخدمين، لتحسين تجربة الجمعيات والمتاجر وتوسيع الخدمات.`,
      description_En: `The first major system update was implemented based on user feedback to enhance the experience for associations and stores, as well as to expand services.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 12,
      date: "3-2014",
      title_Ar: "اطلاق بطاقات RF",
      title_En: "Launching RF cards.",
      description_Ar: `تم تقديم البطاقات الذكية بتقنية RF لتسهيل عمليات الصرف وتوفير أدوات تقنية حديثة تعزز سهولة الاستخدام و مواكبة التطور . `,
      description_En: `Smart RF technology cards were introduced to facilitate disbursement processes and provide modern technological tools that enhance ease of use and keep pace with advancements.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 13,
      date: "9-2015",
      title_Ar: "اطلاق نسخة web",
      title_En: "Launching the web version.",
      description_Ar: `تم تطوير نسخة ويب تفاعلية من النظام مصممة بأحدث التقنيات البرمجية لتحل محل النسخة EXE  ، لتمكين الجمعيات والمتاجر من استخدام النظام  بسهولة وأمان.`,
      description_En: `An interactive web version of the system was developed, designed with the latest software technologies to replace the EXE version, enabling associations and stores to use the system easily and securely.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 14,
      date: "2-2016",
      title_Ar: "اطلاق خدمة القسائم الالكترونية ",
      title_En: "Launching the electronic voucher service.",
      description_Ar: ` أُضيفت ميزة إصدار القسائم الإلكترونية، لتوفير آلية صرف حديثة ومرنة تتناسب مع المشاريع الميدانية ذات طابع السرعة و المرونه و تكون معززة للبطاقات .`,
      description_En: `The electronic voucher issuance feature was added to provide a modern and flexible disbursement mechanism suitable for field projects characterized by speed and flexibility, while also complementing the card system.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 15,
      date: "4-2017",
      title_Ar: "التكامل مع المتاجر والجمعيات",
      title_En: "Integration with stores and associations.",
      description_Ar: `أُتيحت واجهات برمجية (API) لربط النظام بأنظمة الجمعيات الداخلية، لضمان سلاسة في التشغيل وتبادل البيانات.
      و تم تطوير بوابات الربط مع أنظمة نقاط البيع الخاصة بالمتاجر، لتوثيق عمليات الشراء بشكل مباشر وآني و لتحل محل
      اجهزة نقاط البيع التقليدية .`,
      description_En: `Application Programming Interfaces (APIs) were made available to connect the system with associations' internal systems, ensuring seamless operation and data exchange.  
      Integration gateways were developed with stores' point-of-sale (POS) systems to directly and instantly document purchase processes, replacing traditional POS devices.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 16,
      date: "8-2018",
      title_Ar: "اطلاق بوابة الدفع Online",
      title_En: "Launching the Online Payment Portal.",
      description_Ar: `تم إطلاق بوابة Web Pos Online لتسهيل التعامل مع المتاجر التي ترغب في تقليل عدد اجهزة نقاط البيع التقليدية`,
      description_En: `A Web POS Online portal was launched to facilitate transactions with stores looking to reduce the number of traditional point-of-sale devices.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 17,
      date: "4-2019",
      title_Ar: "اطلاق تطبيق منافذ مستفيدين",
      title_En: "Launching the Manafeeth Beneficiaries App.",
      description_Ar: `تماشيًا مع التحول المتسارع في سلوك المجتمع واعتماد الأفراد المتزايد على الأجهزة الذكية، أطلقنا تطبيق "منافذ مستفيدين" على أجهزة iOS وAndroid، لنمنح المستفيدين تجربة رقمية سلسة ومريحة، تعزز من استقلاليتهم وتدعم رؤيتنا في تحويلهم إلى "متسوقين طبيعيين" يتمتعون بالاختيار والكرامة`,
      description_En: ` In line with the rapid shift in societal behavior and the increasing reliance on smart devices, we launched the "Manafeeth Beneficiaries" app on iOS and Android. This provides beneficiaries with a seamless and comfortable digital experience, enhancing their independence and supporting our vision of transforming them into "natural shoppers" who enjoy choice and dignity.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 18,
      date: "9-2020",
      title_Ar: "اطلاق وحدة منافذ ديليفري",
      title_En: "Launching the Manafeeth Delivery module.",
      description_Ar: `استجابة لتحديات جائحة كورونا وصعوبة خروج المستفيدين للتسوّق، أطلقنا "منافذ ديليفري" ليكون حجر الأساس في توصيل المساعدات والسلال الغذائية إلى منازل المستفيدين عبر الجمعيات الخيرية. وقد ساهم النظام بشكل فعّال في تحديد مواقع المستفيدين وإدارة فرق التوصيل بكفاءة، مما ضَمِن استمرار الدعم في أحلك الظروف.`,
      description_En: `In response to the challenges posed by the COVID-19 pandemic and the difficulties beneficiaries faced in going out to shop, we launched "Manafeeth Delivery" as a cornerstone for delivering aid and food baskets to beneficiaries' homes through charitable associations. The system played an effective role in identifying beneficiaries' locations and efficiently managing delivery teams, ensuring continued support during the most challenging times.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 19,
      date: "7-2021",
      title_Ar: "اطلاق وحدة منافذ مانحين ",
      title_En: "Launching the Manafeeth Donors unit.",
      description_Ar: `انطلاقًا من إدراكنا العميق لدور المؤسسات المانحة والأوقاف كشركاء رئيسيين في تمكين الجمعيات و دعمهم ، واستنادًا إلى الحاجة الفعلية لوجود شفافية بين الجمعية والمانح، أنشأنا وحدة "منافذ مانحين". تتيح هذه الوحدة للجهات المانحة ربط دعمها مباشرة بمشاريع الجمعيات داخل منافذ ، مع إمكانية الاطلاع المباشر على التقارير والمخرجات ومؤشرات الأداء بشكل لحظي، مما يعزز الثقة ويضمن رقابة فاعلة على أثر الدعم`,
      description_En: `Driven by our deep understanding of the role of donor institutions and endowments as key partners in enabling and supporting associations, and based on the actual need for transparency between associations and donors, we established the "Manafeeth Donors" unit. This unit allows donors to directly link their support to the associations' projects within Manafeeth, with the ability to access reports, outputs, and performance indicators in real time. This enhances trust and ensures effective oversight of the impact of support.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 20,
      date: "1-2022",
      title_Ar: "التواكب مع الضريبة",
      title_En: "Adapting to Tax Regulations.",
      description_Ar: `تماشيًا مع الأنظمة والتشريعات الضريبية في المملكة، عملت "منافذ" على تحديث بوابات الدفع لدى المتاجر المشاركة، بحيث يتم تمرير بيانات الجمعيات عند تنفيذ عمليات الشراء، ما يُمكّن المتجر من إصدار الفاتورة الضريبية باسم الجمعية مباشرة، تمهيدًا لاسترداد ضريبة القيمة المضافة وفقًا للإجراءات النظامية.`,
      description_En: `In alignment with the tax regulations and legislation in the Kingdom, Manafeeth has updated the payment gateways for participating stores. This ensures that association data is transmitted during purchase transactions, enabling stores to directly issue tax invoices under the association’s name, paving the way for VAT refunds in accordance with official procedures.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 21,
      date: "4-2023",
      title_Ar: "اطلاق وحدة منافذ استثمار",
      title_En: "Launching the Manafeeth Investment unit.",
      description_Ar: `تم إطلاق وحدة "منافذ استثمار" لتمكين الجمعيات من خدمة الأعمال الخيرية الفردية، عبر إصدار بطاقات تبرع مسبقة الدفع تُباع للمتبرعين لتوزيعها بأنفسهم. هذا النموذج يوفّر للجمعية مصدر دخل مستدام، ويعزز دورها المجتمعي في تسهيل التبرع المباشر بطريقة محوكمة وفعّالة.`,
      description_En: `The "Manafeeth Investment" unit was launched to enable associations to serve individual charitable initiatives by issuing prepaid donation cards. These cards are sold to donors for personal distribution. This model provides associations with a sustainable source of income and enhances their community role by facilitating direct donations in a governed and effective manner.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    },
    {
      id: 22,
      date: "4-2024",
      title_Ar: "الانظمام للمركز الوطني",
      title_En: "Joining the National Center.",
      description_Ar: `تم اعتماد "منافذ" كأحد الأنظمة المعتمدة في المركز الوطني لتنمية القطاع غير الربحي، وإدراج المنصة ضمن دليل المركز الرسمي. هذا الاعتماد يعكس ثقة الجهات المختصة بقيمة "منافذ" وأثره الإيجابي في تمكين القطاع الخيري من الرقمنة والحوكمة ورفع كفاءة توزيع المساعدات.`,
      description_En: `Manafeeth has been approved as one of the recognized systems by the National Center for Non-Profit Sector Development and has been included in the Center’s official directory. This endorsement reflects the confidence of the relevant authorities in Manafeeth’s value and its positive impact on enabling the charitable sector to adopt digitalization and governance while enhancing the efficiency of aid distribution.`,
      images: [c_blog_image4, c_blog_image5, c_blog_image6, c_blog_image7]
    }
  ]
};